const state = {
  matches: [],
  selectedMatchId: null,
  isBusy: false,
  imageDataUrl: null,
  imageSource: null,
  detectionRunning: false,
  cameraStream: null,
  cameraActive: false,
  cameraStarting: false,
  cameraReady: false,
  cameraRequestId: 0,
  cameraFacingMode: "environment",
  lastAttemptedQueries: [],
  catalogItems: [],
  activeView: "scan",
  catalogQuery: "",
  catalogGame: "all",
  catalogSort: "recent",
  priceReview: null,
  lastDetectionSource: null,
  scanStage: "capture",
  detectedCard: null,
  lastEstimateAt: null,
  matchSearchSignature: null,
  activeSavedCardId: null,
  currentUserId: resolveCurrentUserId(),
  authUser: null,
  authReady: false,
  aiUsage: null,
  quotas: null
};

const form = document.querySelector("#search-form");
const tabButtons = Array.from(document.querySelectorAll("[data-view-target]"));
const appViews = Array.from(document.querySelectorAll("[data-view]"));
const scanStages = Array.from(document.querySelectorAll("[data-scan-stage]"));
const stepPills = Array.from(document.querySelectorAll("[data-step-pill]"));
const scanFlowStatus = document.querySelector("#scan-flow-status");
const searchButton = document.querySelector("#search-button");
const manualButton = document.querySelector("#manual-button");
const manualEntryButton = document.querySelector("#manual-entry-button");
const backPhotoButton = document.querySelector("#back-photo-button");
const backVerifyPhotoButton = document.querySelector("#back-verify-photo-button");
const confirmMatchButton = document.querySelector("#confirm-match-button");
const editDetectionButton = document.querySelector("#edit-detection-button");
const newScanButton = document.querySelector("#new-scan-button");
const backConditionButton = document.querySelector("#back-condition-button");
const detectButton = document.querySelector("#detect-button");
const imageInput = document.querySelector("#image-input");
const imagePreview = document.querySelector("#image-preview");
const cameraButton = document.querySelector("#camera-button");
const galleryButton = document.querySelector("#gallery-button");
const capturePhotoButton = document.querySelector("#capture-photo-button");
const switchCameraButton = document.querySelector("#switch-camera-button");
const stopCameraButton = document.querySelector("#stop-camera-button");
const aiSummary = document.querySelector("#ai-summary");
const detectedSummary = document.querySelector("#detected-summary");
const resultCardScreen = document.querySelector("#result-card-screen");
const estimationStatus = document.querySelector("#estimation-status");
const detectionStatus = document.querySelector("#detection-status");
const conditionLabelNode = document.querySelector("#condition-label");
const conditionButtons = Array.from(document.querySelectorAll("[data-condition]"));
const notice = document.querySelector("#notice");
const results = document.querySelector("#results");
const selectionBar = document.querySelector("#selection-bar");
const selectionActionBar = document.querySelector("#selection-action-bar");
const selectionActionName = document.querySelector("#selection-action-name");
const addSelectedButton = document.querySelector("#add-selected-button");
const priceReviewPanel = document.querySelector("#price-review-panel");
const matchDrawer = document.querySelector(".match-drawer");
const catalog = document.querySelector("#catalog");
const catalogSummary = document.querySelector("#catalog-summary");
const headerCardCount = document.querySelector("#header-card-count");
const headerTotalValue = document.querySelector("#header-total-value");
const headerQuota = document.querySelector("#header-quota");
const headerUserName = document.querySelector("#header-user-name");
const headerPlanName = document.querySelector("#header-plan-name");
const headerLogoutButton = document.querySelector("#header-logout-button");
const profileQuotaSummary = document.querySelector("#profile-quota-summary");
const mobileQuotaStrip = document.querySelector("#mobile-quota-strip");
const catalogSearch = document.querySelector("#catalog-search");
const catalogGameFilter = document.querySelector("#catalog-game-filter");
const catalogSort = document.querySelector("#catalog-sort");
const statsTotalValue = document.querySelector("#stats-total-value");
const statsEstimatedNote = document.querySelector("#stats-estimated-note");
const statsCardCount = document.querySelector("#stats-card-count");
const statsCopyCount = document.querySelector("#stats-copy-count");
const statsAverageValue = document.querySelector("#stats-average-value");
const statsPurchaseValue = document.querySelector("#stats-purchase-value");
const statsProfitValue = document.querySelector("#stats-profit-value");
const statsGames = document.querySelector("#stats-games");
const statsSources = document.querySelector("#stats-sources");
const statsConditions = document.querySelector("#stats-conditions");
const collectionTotalValue = document.querySelector("#collection-total-value");
const collectionCardCount = document.querySelector("#collection-card-count");
const collectionAverageValue = document.querySelector("#collection-average-value");
const savedCardDetail = document.querySelector("#saved-card-detail");
const backToCatalog = document.querySelector("#back-to-catalog");
const openCostsButton = document.querySelector("#open-costs-button");
const backProfileButton = document.querySelector("#back-profile-button");
const refreshCostsButton = document.querySelector("#refresh-costs-button");
const costsSummary = document.querySelector("#costs-summary");
const network = document.querySelector("#network");
const diagnosticsDrawer = document.querySelector(".diagnostics-drawer");
const attemptedPanel = document.querySelector("#attempted-queries");
const copyAttempted = document.querySelector("#copy-attempted");
const clearAttempted = document.querySelector("#clear-attempted");
const authScreen = document.querySelector("#auth-screen");
const authForm = document.querySelector("#auth-form");
const authUserId = document.querySelector("#auth-user-id");
const authAccessToken = document.querySelector("#auth-access-token");
const authError = document.querySelector("#auth-error");
const logoutButton = document.querySelector("#logout-button");
const tiltMotionQuery = window.matchMedia?.("(prefers-reduced-motion: reduce)") || null;
const scanFlowSteps = [
  { key: "photo", label: "Photo", stages: ["capture"] },
  { key: "ia", label: "IA", stages: ["detecting"] },
  { key: "match", label: "Match", stages: ["verify"] },
  { key: "etat", label: "Etat", stages: ["condition"] },
  { key: "prix", label: "Prix", stages: ["estimating"] },
  { key: "classeur", label: "Classeur", stages: ["result"] }
];

function formValue(name) {
  return new FormData(form).get(name);
}

function setFormValue(name, value) {
  const field = form.elements[name];
  if (!field || value === undefined || value === null) return;
  field.value = value;
}

function formState() {
  return {
    game: String(formValue("game") || "pokemon"),
    name: String(formValue("name") || "").trim(),
    setCode: String(formValue("setCode") || "").trim(),
    collectorNumber: String(formValue("collectorNumber") || "").trim(),
    language: String(formValue("language") || "fr"),
    condition: String(formValue("condition") || "near_mint"),
    quantity: Number(formValue("quantity") || 1),
    manualPrice: formValue("manualPrice") === "" ? null : Number(formValue("manualPrice")),
    purchasePrice: formValue("purchasePrice") === "" ? null : Number(formValue("purchasePrice")),
    isFoil: Boolean(formValue("isFoil"))
  };
}

function showNotice(message, type = "success") {
  notice.hidden = false;
  notice.textContent = message;
  notice.className = `notice ${type}`;
}

function hideNotice() {
  notice.hidden = true;
  notice.textContent = "";
}

function emptyPreviewHtml() {
  return scannerPreviewHtml({
    title: "Scanner une carte",
    detail: "Lance la camera live ou importe une photo depuis la phototheque.",
    status: "Carte a aligner",
    mode: "empty"
  });
}

function scannerQuotaText() {
  const quota = quotaByMetric("card_detection");
  if (!quota) return "Scans restants : --";
  const remaining = Number(quota.remaining);
  const limit = Number(quota.limit);
  if (!Number.isFinite(remaining) || !Number.isFinite(limit)) return "Scans restants : --";
  return `Scans restants : ${Math.max(0, Math.floor(remaining))}/${Math.floor(limit)}`;
}

function scannerPreviewHtml({ imageHtml = "", videoHtml = "", thumbHtml = "", title, detail, status, mode = "empty" }) {
  const ready = mode === "ready";
  const live = mode === "camera";
  const error = mode === "error";
  const inner = imageHtml
    ? `<div class="scanner-card-photo">${imageHtml}</div>`
    : live
    ? `
      <div class="scanner-live-guide">
        <strong>Aligne la carte</strong>
        <small>Remplis le cadre, puis capture.</small>
      </div>
    `
    : `
      <div class="scanner-placeholder">
        <span class="capture-prompt-icon ${error ? "danger" : ""}">${error ? "MAX" : "VC"}</span>
        <strong>${escapeHtml(title)}</strong>
        <small>${escapeHtml(detail)}</small>
      </div>
  `;
  const thumb = thumbHtml || imageHtml;
  return `
    <div class="scanner-camera ${ready ? "ready" : ""} ${live ? "live" : ""} ${error ? "error" : ""}">
      ${
        videoHtml
          ? `<div id="camera-video-layer" class="scanner-video-layer">
              <video id="camera-video" class="scanner-video" autoplay muted playsinline webkit-playsinline></video>
              <span class="scanner-video-fallback">Ouverture camera...</span>
            </div>`
          : ""
      }
      <div class="scanner-vignette" aria-hidden="true"></div>
      <div class="scanner-live-dot" aria-hidden="true"></div>
      <div class="scanner-tools scanner-tools-left" aria-hidden="true">
        ${live ? "<span>LIVE</span><span>IA</span>" : "<span>SET</span><span>?</span><span>FR</span><span>Q</span>"}
      </div>
      <div class="scanner-tools scanner-tools-right" aria-hidden="true">
        <span>${live ? "SCAN" : "x"}</span>
      </div>
      <div class="scanner-target ${ready || live ? "locked" : ""}">
        ${inner}
        <span class="corner top-left"></span>
        <span class="corner top-right"></span>
        <span class="corner bottom-left"></span>
        <span class="corner bottom-right"></span>
      </div>
      <div class="scanner-bottom">
        <span class="scanner-quota" data-scanner-quota>${escapeHtml(scannerQuotaText())}</span>
        ${live ? `<span class="scanner-camera-status" data-camera-status>${escapeHtml(status || "Ouverture camera...")}</span>` : ""}
        <div class="scanner-controls" aria-hidden="true">
          <span class="scanner-pulse">${live ? "auto" : "scan"}</span>
          <span class="scanner-speed">x1</span>
          <span class="scanner-shutter"></span>
          <span class="scanner-zoom"><i></i></span>
          <span class="scanner-zoom-value">x1.0</span>
          <span class="scanner-pause">II</span>
        </div>
        ${
          ready
            ? `<div class="scanner-result-strip">
                <span>${thumb}</span>
                <strong>${escapeHtml(status || "Photo prete")}</strong>
                <small>Detection IA puis comparaison visuelle</small>
              </div>`
            : ""
        }
      </div>
    </div>
  `;
}

function refreshScannerQuotaText() {
  imagePreview?.querySelectorAll("[data-scanner-quota]").forEach((node) => {
    node.textContent = scannerQuotaText();
  });
}

function updateDetectButtonState({ loading = false } = {}) {
  if (!detectButton) return;
  if (loading) {
    detectButton.disabled = true;
    detectButton.textContent = "Lecture IA...";
    return;
  }
  const hasImage = Boolean(state.imageDataUrl);
  detectButton.disabled = !hasImage;
  detectButton.textContent = hasImage ? "Detecter par IA" : "Ajoute une photo";
}

function cameraSupported() {
  return Boolean(window.isSecureContext && navigator.mediaDevices?.getUserMedia);
}

function updateCameraControls() {
  const supported = cameraSupported();
  const cameraControlsVisible = state.cameraActive || state.cameraStarting;
  if (cameraButton) {
    cameraButton.disabled = state.cameraActive || state.cameraStarting || !supported;
    cameraButton.textContent = supported
      ? state.cameraStarting
        ? "Ouverture camera..."
        : state.cameraActive
        ? "Camera active"
        : "Camera live"
      : "Camera indisponible";
  }
  if (galleryButton) galleryButton.disabled = false;
  if (capturePhotoButton) {
    capturePhotoButton.hidden = !cameraControlsVisible;
    capturePhotoButton.disabled = !state.cameraReady;
    capturePhotoButton.textContent = state.cameraReady ? "Scanner maintenant" : "Ouverture...";
  }
  if (switchCameraButton) {
    switchCameraButton.hidden = !cameraControlsVisible;
    switchCameraButton.disabled = state.cameraStarting;
  }
  if (stopCameraButton) {
    stopCameraButton.hidden = !cameraControlsVisible;
    stopCameraButton.disabled = false;
  }
}

function cameraErrorMessage(error) {
  const name = String(error?.name || "");
  if (!window.isSecureContext) {
    return "Camera disponible uniquement en HTTPS ou localhost. Ouvre l'app via le domaine HTTPS de Valeo Card.";
  }
  if (name === "NotAllowedError" || name === "SecurityError") {
    return "Autorisation camera refusee. Utilise la phototheque ou autorise la camera dans le navigateur.";
  }
  if (name === "NotFoundError" || name === "OverconstrainedError") {
    return "Aucune camera compatible trouvee. La phototheque reste disponible.";
  }
  return "Camera indisponible pour le moment. La phototheque reste disponible.";
}

function stopCameraStream({ resetPreview = false } = {}) {
  state.cameraRequestId += 1;
  state.cameraStarting = false;
  state.cameraReady = false;
  if (state.cameraStream) {
    state.cameraStream.getTracks().forEach((track) => track.stop());
  }
  const video = imagePreview?.querySelector("#camera-video");
  if (video) video.srcObject = null;
  state.cameraStream = null;
  state.cameraActive = false;
  imagePreview?.classList.remove("has-camera");
  updateCameraControls();

  if (resetPreview && !state.imageDataUrl && imagePreview) {
    imagePreview.classList.remove("has-image", "has-error");
    imagePreview.innerHTML = emptyPreviewHtml();
    setImagePreviewTilt(false);
    if (aiSummary) {
      aiSummary.textContent = "Lance la camera live ou choisis une photo depuis la phototheque.";
    }
    updateDetectButtonState();
  }
}

function renderCameraError(error) {
  state.cameraRequestId += 1;
  state.cameraStarting = false;
  state.cameraReady = false;
  if (state.cameraStream) {
    state.cameraStream.getTracks().forEach((track) => track.stop());
  }
  const video = imagePreview?.querySelector("#camera-video");
  if (video) video.srcObject = null;
  state.cameraStream = null;
  state.cameraActive = false;
  state.imageDataUrl = null;
  state.imageSource = null;
  imagePreview?.classList.remove("has-image", "has-camera");
  imagePreview?.classList.add("has-error");
  if (imagePreview) {
    imagePreview.innerHTML = scannerPreviewHtml({
      title: "Camera indisponible",
      detail: "Utilise la phototheque pour continuer le scan.",
      status: "Fallback phototheque",
      mode: "error"
    });
  }
  setImagePreviewTilt(false);
  updateDetectButtonState();
  updateCameraControls();
  showNotice(cameraErrorMessage(error), "error");
}

function setCameraStatus(message) {
  const text = String(message || "");
  imagePreview?.querySelector("[data-camera-status]")?.replaceChildren(document.createTextNode(text));
  if (aiSummary && text) aiSummary.textContent = text;
}

function markCameraFrameReady(video) {
  if (!state.cameraActive || video.srcObject !== state.cameraStream) return;
  state.cameraReady = true;
  imagePreview?.querySelector("#camera-video-layer")?.classList.add("has-stream", "has-frame");
  updateCameraControls();
  setCameraStatus(`Camera active (${video.videoWidth}x${video.videoHeight}). Cadre la carte puis capture.`);
}

async function waitForVideoFrame(video) {
  let playError = null;
  setCameraStatus("Demarrage du flux video...");
  await video.play().catch((error) => {
    playError = error;
  });

  if (video.videoWidth > 0 && video.videoHeight > 0) {
    markCameraFrameReady(video);
    return;
  }

  await new Promise((resolve) => {
    let done = false;
    let frameHandle = null;
    const finish = () => {
      if (done) return;
      done = true;
      window.clearTimeout(timer);
      video.removeEventListener("loadedmetadata", finish);
      video.removeEventListener("loadeddata", finish);
      video.removeEventListener("canplay", finish);
      video.removeEventListener("playing", finish);
      resolve();
    };
    const timer = window.setTimeout(finish, 3500);
    video.addEventListener("loadedmetadata", finish, { once: true });
    video.addEventListener("loadeddata", finish, { once: true });
    video.addEventListener("canplay", finish, { once: true });
    video.addEventListener("playing", finish, { once: true });
    if (typeof video.requestVideoFrameCallback === "function") {
      frameHandle = video.requestVideoFrameCallback(finish);
    }
    if (frameHandle === null && video.readyState >= 2) finish();
  });

  if (video.videoWidth > 0 && video.videoHeight > 0) {
    markCameraFrameReady(video);
    return;
  }

  if (playError) {
    const message = "Camera autorisee, mais lecture video bloquee. Reessaie Camera live ou utilise la phototheque.";
    stopCameraStream({ resetPreview: true });
    if (aiSummary) aiSummary.textContent = message;
    showNotice(message, "error");
    return;
  }
  const message = "Camera ouverte, mais aucune image video n'arrive. Reessaie Camera live ou importe depuis la phototheque.";
  stopCameraStream({ resetPreview: true });
  if (aiSummary) aiSummary.textContent = message;
  showNotice(message, "error");
}

async function requestCameraStream(facingMode) {
  const constraintsList = [
    {
      video: {
        facingMode,
        width: { ideal: 1280 },
        height: { ideal: 720 }
      },
      audio: false
    },
    {
      video: {
        facingMode: { ideal: facingMode },
        width: { ideal: 1280 },
        height: { ideal: 720 }
      },
      audio: false
    },
    { video: true, audio: false }
  ];
  let lastError = null;
  for (const constraints of constraintsList) {
    try {
      return await navigator.mediaDevices.getUserMedia(constraints);
    } catch (error) {
      if (error?.name === "NotAllowedError" || error?.name === "SecurityError") throw error;
      lastError = error;
    }
  }
  throw lastError || new Error("Camera indisponible");
}

function attachCameraStream(stream) {
  const video = imagePreview?.querySelector("#camera-video");
  const layer = imagePreview?.querySelector("#camera-video-layer");
  if (!video) return null;
  layer?.classList.remove("has-frame");
  layer?.classList.add("has-stream");
  video.muted = true;
  video.defaultMuted = true;
  video.autoplay = true;
  video.playsInline = true;
  video.controls = false;
  video.style.opacity = "1";
  video.style.visibility = "visible";
  try {
    video.disablePictureInPicture = true;
  } catch {
    // Safari iOS peut ignorer cette propriete.
  }
  const markReadyWhenPlayable = () => {
    if (!state.cameraActive || video.srcObject !== state.cameraStream) return;
    if (video.videoWidth > 0 && video.videoHeight > 0) markCameraFrameReady(video);
  };
  video.addEventListener("loadedmetadata", markReadyWhenPlayable, { once: true });
  video.addEventListener("loadeddata", markReadyWhenPlayable, { once: true });
  video.addEventListener("canplay", markReadyWhenPlayable, { once: true });
  video.addEventListener("playing", markReadyWhenPlayable, { once: true });
  video.setAttribute("playsinline", "");
  video.setAttribute("webkit-playsinline", "");
  video.setAttribute("autoplay", "");
  video.setAttribute("muted", "");
  video.setAttribute("aria-label", "Vue camera live");
  video.srcObject = stream;
  return video;
}

async function startCamera({ keepNotice = false } = {}) {
  if (!cameraSupported()) {
    renderCameraError(new Error("getUserMedia unsupported"));
    return;
  }

  if (!keepNotice) hideNotice();
  stopCameraStream();
  const requestId = state.cameraRequestId + 1;
  state.cameraRequestId = requestId;
  state.cameraStarting = true;
  updateCameraControls();
  state.imageDataUrl = null;
  state.imageSource = null;
  imageInput.value = "";
  updateDetectButtonState();
  setImagePreviewTilt(false);
  imagePreview.classList.remove("has-image", "has-error");
  imagePreview.classList.add("has-camera");
  imagePreview.innerHTML = scannerPreviewHtml({
    videoHtml: "camera",
    title: "Camera active",
    detail: "Place la carte dans le cadre puis capture.",
    status: "Autorisation camera...",
    mode: "camera"
  });
  if (aiSummary) {
    aiSummary.textContent = "Autorise la camera, puis attends l'image video.";
  }

  let stream = null;
  try {
    stream = await requestCameraStream(state.cameraFacingMode);
  } catch (error) {
    state.cameraStarting = false;
    renderCameraError(error);
    return;
  }

  if (requestId !== state.cameraRequestId) {
    stream.getTracks().forEach((track) => track.stop());
    return;
  }

  state.cameraStream = stream;
  state.cameraActive = true;
  state.cameraStarting = false;
  state.cameraReady = false;
  updateCameraControls();
  const video = attachCameraStream(stream);
  if (!video) {
    stopCameraStream({ resetPreview: true });
    showNotice("Preview camera introuvable. Relance la camera ou utilise la phototheque.", "error");
    return;
  }
  await waitForVideoFrame(video);
}

function canvasFromVideoFrame(video) {
  const sourceWidth = video.videoWidth || 1280;
  const sourceHeight = video.videoHeight || 1920;
  const aspect = 5 / 7;
  let cropHeight = Math.min(sourceHeight * 0.82, (sourceWidth / aspect) * 0.92);
  let cropWidth = cropHeight * aspect;
  if (cropWidth > sourceWidth * 0.92) {
    cropWidth = sourceWidth * 0.92;
    cropHeight = cropWidth / aspect;
  }
  const centerY = sourceHeight * 0.44;
  const sx = Math.max(0, (sourceWidth - cropWidth) / 2);
  const sy = Math.max(0, Math.min(sourceHeight - cropHeight, centerY - cropHeight / 2));
  const scale = Math.min(1, 1600 / Math.max(cropWidth, cropHeight));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(cropWidth * scale));
  canvas.height = Math.max(1, Math.round(cropHeight * scale));
  const context = canvas.getContext("2d", { alpha: false });
  context.drawImage(video, sx, sy, cropWidth, cropHeight, 0, 0, canvas.width, canvas.height);
  return canvas;
}

function canvasFrameQuality(canvas) {
  const sampleSize = 18;
  const sample = document.createElement("canvas");
  sample.width = sampleSize;
  sample.height = sampleSize;
  const context = sample.getContext("2d", { alpha: false });
  context.drawImage(canvas, 0, 0, sampleSize, sampleSize);
  const pixels = context.getImageData(0, 0, sampleSize, sampleSize).data;
  let sum = 0;
  let sumSq = 0;
  let min = 255;
  let max = 0;
  const count = sampleSize * sampleSize;
  for (let i = 0; i < pixels.length; i += 4) {
    const luma = 0.2126 * pixels[i] + 0.7152 * pixels[i + 1] + 0.0722 * pixels[i + 2];
    sum += luma;
    sumSq += luma * luma;
    min = Math.min(min, luma);
    max = Math.max(max, luma);
  }
  const mean = sum / count;
  const variance = Math.max(0, sumSq / count - mean * mean);
  return { mean, variance, range: max - min };
}

function isUsableCameraFrame(canvas) {
  const quality = canvasFrameQuality(canvas);
  return quality.mean > 8 && quality.range > 10 && quality.variance > 6;
}

async function captureCameraFrame({ autoDetect = true } = {}) {
  if (!state.cameraActive) {
    await startCamera();
    return;
  }
  const video = imagePreview?.querySelector("#camera-video");
  if (!video || !state.cameraReady || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA || !video.videoWidth || !video.videoHeight) {
    showNotice("La camera demarre encore. Attends que l'image apparaisse, puis capture.", "error");
    return;
  }

  const canvas = canvasFromVideoFrame(video);
  if (!isUsableCameraFrame(canvas)) {
    setCameraStatus("Image trop sombre ou pas encore chargee. Repositionne la carte puis rescane.");
    showNotice("La capture camera est noire ou trop uniforme. Repositionne la carte sous plus de lumiere puis rescane.", "error");
    return;
  }
  state.imageDataUrl = canvas.toDataURL("image/jpeg", 0.88);
  state.imageSource = "camera";
  stopCameraStream();
  imagePreview.classList.add("has-image");
  imagePreview.classList.remove("has-error", "has-camera");
  imagePreview.innerHTML = scannerPreviewHtml({
    imageHtml: `<img src="${state.imageDataUrl}" alt="Photo de carte capturee" />`,
    title: "Photo capturee",
    detail: "Lance la detection IA.",
    status: "Photo capturee",
    mode: "ready"
  });
  setImagePreviewTilt(false);
  if (aiSummary) aiSummary.textContent = autoDetect ? "Photo capturee. Detection IA en cours..." : "Photo capturee. Tu peux lancer la detection IA ou reprendre une photo.";
  updateDetectButtonState();
  if (autoDetect) {
    window.setTimeout(() => {
      if (!state.imageDataUrl || state.scanStage !== "capture") return;
      detectCard().catch((error) => showNotice(error.message, "error"));
    }, 120);
  }
}

async function switchCameraFacing() {
  state.cameraFacingMode = state.cameraFacingMode === "environment" ? "user" : "environment";
  if (state.cameraActive) {
    await startCamera();
  }
}

function openGalleryPicker() {
  stopCameraStream();
  imageInput.click();
}

function activatePreviewCapture() {
  if (state.cameraActive) {
    captureCameraFrame().catch((error) => showNotice(error.message, "error"));
    return;
  }
  startCamera().catch((error) => showNotice(error.message, "error"));
}

function scanFlowIndex(stage = state.scanStage) {
  const index = scanFlowSteps.findIndex((step) => step.stages.includes(stage));
  return index === -1 ? 0 : index;
}

function renderScanProgress() {
  const activeIndex = scanFlowIndex();
  const activeStep = scanFlowSteps[activeIndex] || scanFlowSteps[0];
  if (scanFlowStatus) {
    scanFlowStatus.textContent = `${activeIndex + 1}/${scanFlowSteps.length} - ${activeStep.label}`;
  }
  stepPills.forEach((pill) => {
    const index = scanFlowSteps.findIndex((step) => step.key === pill.dataset.stepPill);
    const stateName = index < activeIndex ? "done" : index === activeIndex ? "active" : "pending";
    pill.dataset.state = stateName;
    if (stateName === "active") pill.setAttribute("aria-current", "step");
    else pill.removeAttribute("aria-current");
  });
}

function resolveCurrentUserId() {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = normalizeUserId(params.get("user"));
  if (fromUrl) {
    try {
      window.localStorage?.setItem("valeo:userId", fromUrl);
    } catch {
      // Storage can be unavailable in private or embedded contexts.
    }
    return fromUrl;
  }
  try {
    return normalizeUserId(window.localStorage?.getItem("valeo:userId")) || "local-user";
  } catch {
    return "local-user";
  }
}

function normalizeUserId(value) {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 64);
  return normalized || "";
}

async function api(path, options = {}) {
  const response = await fetch(path, {
    ...options,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    }
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.error || `Erreur HTTP ${response.status}`);
    error.quota = payload.quota;
    if (response.status === 401) showAuthScreen(error.message);
    throw error;
  }
  return payload;
}

function showAuthScreen(message = "") {
  stopCameraStream({ resetPreview: true });
  state.authReady = false;
  if (authScreen) authScreen.hidden = false;
  document.querySelector(".app-shell")?.setAttribute("aria-hidden", "true");
  if (authError) {
    authError.hidden = !message;
    authError.textContent = message;
  }
  if (authUserId && !authUserId.value) authUserId.value = state.currentUserId === "local-user" ? "" : state.currentUserId;
}

function hideAuthScreen() {
  state.authReady = true;
  if (authScreen) authScreen.hidden = true;
  document.querySelector(".app-shell")?.removeAttribute("aria-hidden");
  if (authError) {
    authError.hidden = true;
    authError.textContent = "";
  }
}

function currency(value, code = "EUR") {
  if (value === null || value === undefined) return "Non estime";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: code || "EUR"
  }).format(value);
}

function compactCurrency(value, code = "EUR") {
  if (!Number.isFinite(Number(value))) return currency(0, code);
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: code || "EUR",
    maximumFractionDigits: Number(value) >= 1000 ? 0 : 2
  }).format(value);
}

function usdCost(value) {
  if (!Number.isFinite(Number(value))) return "Non calcule";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: Number(value) < 0.01 ? 5 : 2,
    maximumFractionDigits: Number(value) < 0.01 ? 5 : 4
  }).format(Number(value));
}

function formatDateTime(value) {
  if (!value) return "Pas encore analysee";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("fr-FR", {
    dateStyle: "medium",
    timeStyle: "short"
  }).format(date);
}

function confidence(value) {
  return value ? `${Math.round(value * 100)}%` : "score n/a";
}

function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");
}

function shortUrl(url) {
  return String(url || "").replace(/^https?:\/\//, "").replace(/\?.*$/, "");
}

function cardImageSrc(value) {
  const raw = String(value || "");
  try {
    const url = new URL(raw);
    const proxiedHosts = new Set([
      "en.onepiece-cardgame.com",
      "images.pokemontcg.io",
      "cards.scryfall.io",
      "images.ygoprodeck.com"
    ]);
    if (proxiedHosts.has(url.hostname)) {
      return `/api/card-image?url=${encodeURIComponent(url.toString())}`;
    }
  } catch {
    return raw;
  }
  return raw;
}

function card3dArtHtml({ className, contentHtml, label = "", intro = false, idle = true }) {
  const attrs = [
    "data-card3d",
    intro ? 'data-card3d-intro="true"' : "",
    idle ? "" : 'data-card3d-idle="false"'
  ]
    .filter(Boolean)
    .join(" ");
  return `
    <div class="${className} vc-card3d" ${attrs}>
      <div class="vc-card3d-inner" data-card3d-inner>
        ${contentHtml}
        ${
          label
            ? `<span class="card3d-badge" aria-hidden="true">${escapeHtml(String(label).slice(0, 10))}</span>`
            : ""
        }
        <div class="vc-card3d-glare" data-card3d-glare></div>
        <div class="vc-card3d-foil" data-card3d-foil></div>
        <div class="vc-card3d-edge" data-card3d-edge></div>
      </div>
    </div>
  `;
}

function comparableText(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-zA-Z0-9]+/g, " ")
    .trim()
    .toLowerCase();
}

function comparableCollectorNumber(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const leftSide = raw.split("/")[0].trim();
  return leftSide.replace(/^0+(\d)/, "$1").toUpperCase();
}

function matchVariantLabel(match) {
  if (match?.variantLabel) return match.variantLabel;
  const suffix = String(match?.providerCardId || "").match(/_(p\d+)$/i)?.[1];
  if (suffix) return `Variante ${suffix.toUpperCase()}`;
  return "Standard";
}

function cardNameValues(card) {
  return [
    card?.name,
    card?.displayName,
    String(card?.displayName || "").replace(/\s*\([^)]*\)\s*$/g, "")
  ]
    .map(comparableText)
    .filter(Boolean);
}

function wantedNameValues() {
  const detection = state.detectedCard || {};
  return [
    formState().name,
    detection.name,
    detection.nameEn,
    ...(Array.isArray(detection.searchNames) ? detection.searchNames : [])
  ]
    .map(comparableText)
    .filter(Boolean);
}

function baseCardKey(match) {
  if (!match) return "";
  const names = cardNameValues(match);
  return [
    match.game || "",
    names[0] || "",
    comparableCollectorNumber(match.collectorNumber)
  ].join("|");
}

function samePlayableCard(match, wantedNames, wantedNumber) {
  const candidateNames = cardNameValues(match);
  const sameName =
    !wantedNames.length ||
    candidateNames.some((candidate) =>
      wantedNames.some((wanted) => candidate === wanted || candidate.includes(wanted) || wanted.includes(candidate))
    );
  const sameNumber = !wantedNumber || comparableCollectorNumber(match.collectorNumber) === wantedNumber;
  return sameName && sameNumber;
}

function detectionVisualKey(value = "") {
  return comparableText(value).replace(/\s+/g, "_");
}

function shouldLockVisualMatch(match) {
  const detection = state.detectedCard || {};
  const wantedVariant = detectionVisualKey(detection.visualVariant);
  const matchVariant = detectionVisualKey(match?.visualVariant);
  const detectionText = comparableText(
    [
      detection.visualVariant,
      detection.artDescription,
      detection.specialStamp,
      detection.illustrator,
      ...(Array.isArray(detection.searchQueries) ? detection.searchQueries : [])
    ].join(" ")
  );
  const matchText = comparableText([match?.visualVariant, match?.artDescription, match?.variantLabel, match?.illustrator].join(" "));

  if (wantedVariant && matchVariant && wantedVariant === matchVariant && Number(match.confidence || 0) >= 0.9) return true;
  if (detectionText && matchText) {
    const treasureWanted = /\b(treasure|crown|couronne|tresor|coins?|pieces?|or)\b/.test(detectionText);
    const treasureMatch = /\b(treasure|crown|couronne|tresor|coins?|pieces?|or)\b/.test(matchText);
    if (treasureWanted && treasureMatch && Number(match.confidence || 0) >= 0.85) return true;
  }
  return false;
}

function variantMatchesForSelected() {
  const selected = selectedMatch();
  if (selected) {
    const key = baseCardKey(selected);
    return state.matches.filter((match) => baseCardKey(match) === key);
  }

  const wantedNames = wantedNameValues();
  const wantedNumber = comparableCollectorNumber(formState().collectorNumber || state.detectedCard?.collectorNumber);

  if (!wantedNames.length && !wantedNumber) return state.matches;
  return state.matches.filter((match) => samePlayableCard(match, wantedNames, wantedNumber));
}

function validationCandidateMatches() {
  const selected = selectedMatch();
  const candidates = [];
  const seen = new Set();

  function add(match) {
    if (!match?.providerCardId || seen.has(match.providerCardId)) return;
    seen.add(match.providerCardId);
    candidates.push(match);
  }

  add(selected);
  state.matches.forEach(add);
  return candidates;
}

function shouldAutoSelectMatch(matches) {
  if (!Array.isArray(matches) || matches.length === 0) return null;
  const first = matches[0];
  if (first?.autoSelectable) return first.providerCardId;
  if (matches.length === 1 && first?.matchStatus === "confirmed" && Number(first.matchScore || first.confidence || 0) >= 0.82) {
    return first.providerCardId;
  }

  if (first?.matchStatus === "confirmed" && shouldLockVisualMatch(first)) return first.providerCardId;

  // Des qu'il y a plusieurs candidats, le numero ou le nom ne suffit pas:
  // l'utilisateur doit comparer l'artwork avant que l'estimation soit lancee.
  return null;
}

function tiltMotionAllowed() {
  return Boolean(window.PointerEvent) && !tiltMotionQuery?.matches;
}

function clampTiltRatio(value) {
  return Math.min(1, Math.max(0, value));
}

function tiltCardsIn(root = document) {
  const cards = new Set();
  if (root?.nodeType === 1 && root.matches?.("[data-tilt-card], [data-card3d]")) cards.add(root);
  root?.querySelectorAll?.("[data-tilt-card], [data-card3d]").forEach((card) => cards.add(card));
  return Array.from(cards);
}

function tiltTouchOwnsGesture(card) {
  return Boolean(card?.closest?.("#card-view, .catalog-list") || card?.classList?.contains("saved-card-art"));
}

function preventTiltPageScroll(card, event) {
  if (event.pointerType !== "touch" || !tiltTouchOwnsGesture(card)) return;
  if (event.cancelable) event.preventDefault();
}

function card3dParts(card) {
  return {
    inner: card.querySelector?.("[data-card3d-inner]") || card,
    glare: card.querySelector?.("[data-card3d-glare]") || null,
    foil: card.querySelector?.("[data-card3d-foil]") || null,
    edge: card.querySelector?.("[data-card3d-edge]") || null
  };
}

function foilGradient(angleDeg, opacity = 1) {
  const alpha = Number(opacity).toFixed(2);
  return (
    `linear-gradient(${angleDeg.toFixed(1)}deg,` +
    `rgba(255,0,0,${alpha}) 0%,` +
    `rgba(255,140,0,${alpha}) 16%,` +
    `rgba(255,230,0,${alpha}) 33%,` +
    `rgba(0,200,80,${alpha}) 50%,` +
    `rgba(0,120,255,${alpha}) 66%,` +
    `rgba(140,0,255,${alpha}) 83%,` +
    `rgba(255,0,160,${alpha}) 100%)`
  );
}

function edgeLightGradient(right, left, top, bottom) {
  const edgeColor = (intensity) => {
    const clamped = Math.max(0, Math.min(1, intensity));
    const value = Math.round(180 + clamped * 75);
    return `rgba(${value},${value},${Math.round(200 + clamped * 55)},${(0.5 + clamped * 0.5).toFixed(2)})`;
  };
  return [
    `linear-gradient(to left, ${edgeColor(right)}, transparent) right center / 3px 100% no-repeat`,
    `linear-gradient(to right, ${edgeColor(left)}, transparent) left center / 3px 100% no-repeat`,
    `linear-gradient(to bottom, ${edgeColor(top)}, transparent) center top / 100% 3px no-repeat`,
    `linear-gradient(to top, ${edgeColor(bottom)}, transparent) center bottom / 100% 3px no-repeat`
  ].join(", ");
}

function edgeShadows(rotX, rotY, maxTilt) {
  const shadows = [];
  for (let i = 1; i <= 10; i += 1) {
    const ox = (-rotY / maxTilt) * i * 0.6;
    const oy = (rotX / maxTilt) * i * 0.6;
    const shade = Math.round(210 - (i / 10) * 80);
    shadows.push(`${ox.toFixed(1)}px ${oy.toFixed(1)}px 0 rgb(${shade},${shade - 8},${shade - 16})`);
  }
  const dropX = (-rotY / maxTilt) * 15;
  const dropY = 10 + (rotX / maxTilt) * 10;
  shadows.push(`${dropX.toFixed(1)}px ${dropY.toFixed(1)}px 30px rgba(0,0,0,0.45)`);
  return shadows.join(", ");
}

function resetTiltCard(card) {
  if (!card) return;
  const parts = card3dParts(card);
  const idleOpacity = card.dataset.card3dIdle === "false" ? "0" : "0.18";
  delete card.dataset.tiltActive;
  card.classList.remove("is-tilting");
  card.style.setProperty("--rx", "0deg");
  card.style.setProperty("--ry", "0deg");
  card.style.setProperty("--gx", "50%");
  card.style.setProperty("--gy", "45%");
  card.style.setProperty("--foil-angle", "135deg");
  card.style.setProperty("--foil-opacity", "0.14");
  if (parts.inner !== card) {
    parts.inner.style.transition = "transform 0.6s cubic-bezier(.03,.98,.52,.99), box-shadow 0.6s ease";
    parts.inner.style.transform = "rotateX(0deg) rotateY(0deg) scale3d(1,1,1)";
    parts.inner.style.boxShadow = "0 8px 30px rgba(0,0,0,0.35)";
  }
  if (parts.glare) {
    parts.glare.style.transition = "opacity 0.6s ease";
    parts.glare.style.opacity = "0";
  }
  if (parts.foil) {
    parts.foil.style.transition = "opacity 0.6s ease";
    parts.foil.style.opacity = idleOpacity;
    parts.foil.style.background = foilGradient(115, 0.1);
  }
  if (parts.edge) {
    parts.edge.style.transition = "opacity 0.6s ease";
    parts.edge.style.opacity = "0";
  }
}

function updateTiltCard(card, event) {
  if (!tiltMotionAllowed()) {
    resetTiltCard(card);
    return;
  }
  const rect = card.getBoundingClientRect();
  if (!rect.width || !rect.height) return;
  const x = clampTiltRatio((event.clientX - rect.left) / rect.width);
  const y = clampTiltRatio((event.clientY - rect.top) / rect.height);
  const dx = x * 2 - 1;
  const dy = y * 2 - 1;
  const maxTilt = 20;
  const rx = -dy * maxTilt;
  const ry = dx * maxTilt;
  const intensity = (Math.abs(dx) + Math.abs(dy)) / 2;
  const angle = 110 + dx * 80 + dy * 40;
  const parts = card3dParts(card);

  card.classList.add("is-tilting");
  card.style.setProperty("--rx", `${rx.toFixed(2)}deg`);
  card.style.setProperty("--ry", `${ry.toFixed(2)}deg`);
  card.style.setProperty("--gx", `${(x * 100).toFixed(1)}%`);
  card.style.setProperty("--gy", `${(y * 100).toFixed(1)}%`);
  card.style.setProperty("--foil-angle", `${angle.toFixed(1)}deg`);
  card.style.setProperty("--foil-opacity", Math.min(0.95, 0.48 + intensity * 0.55).toFixed(2));
  if (parts.inner !== card) {
    parts.inner.style.transition = "transform 0.1s ease-out";
    parts.inner.style.transform = `rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg) scale3d(1.03,1.03,1.03)`;
    parts.inner.style.boxShadow = edgeShadows(rx, ry, maxTilt);
  }
  if (parts.glare) {
    parts.glare.style.transition = "opacity 0.1s ease-out";
    parts.glare.style.opacity = "1";
    parts.glare.style.background = `radial-gradient(ellipse at ${(x * 100).toFixed(1)}% ${(y * 100).toFixed(1)}%, rgba(255,255,255,${(0.1 + intensity * 0.28).toFixed(2)}) 0%, rgba(200,210,255,${(0.04 + intensity * 0.1).toFixed(2)}) 40%, transparent 70%)`;
  }
  if (parts.foil) {
    parts.foil.style.transition = "opacity 0.1s ease-out";
    parts.foil.style.opacity = Math.min(0.55, 0.12 + intensity * 0.38).toFixed(2);
    parts.foil.style.background = foilGradient(angle, 1);
  }
  if (parts.edge) {
    parts.edge.style.transition = "opacity 0.1s ease-out";
    parts.edge.style.opacity = (0.4 + intensity * 0.6).toFixed(2);
    parts.edge.style.background = edgeLightGradient(Math.max(0, dx), Math.max(0, -dx), Math.max(0, -dy), Math.max(0, dy));
  }
}

function playCard3dIntro(card) {
  if (!tiltMotionAllowed() || card.dataset.card3dIntroPlayed === "true") return;
  const parts = card3dParts(card);
  if (parts.inner === card) return;
  card.dataset.card3dIntroPlayed = "true";
  window.setTimeout(() => {
    if (card.dataset.tiltActive === "true" || card.classList.contains("is-tilting")) return;
    const start = performance.now();
    const duration = 1500;
    const tick = (now) => {
      if (card.dataset.tiltActive === "true" || card.classList.contains("is-tilting")) return;
      const t = Math.min((now - start) / duration, 1);
      const eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      const phase = -Math.sin(eased * Math.PI * 2);
      parts.inner.style.transition = "none";
      parts.inner.style.transform = `rotateX(0deg) rotateY(${(phase * 8).toFixed(1)}deg) scale3d(1.02,1.02,1.02)`;
      if (parts.foil) {
        parts.foil.style.opacity = "0.24";
        parts.foil.style.background = foilGradient(90 + phase * 70, 0.16);
      }
      if (t < 1) {
        window.requestAnimationFrame(tick);
        return;
      }
      resetTiltCard(card);
    };
    window.requestAnimationFrame(tick);
  }, 400);
}

function bindTiltCards(root = document) {
  tiltCardsIn(root).forEach((card) => {
    if (card.dataset.tiltBound === "true") return;
    card.dataset.tiltBound = "true";
    resetTiltCard(card);
    if (card.dataset.card3dIntro === "true") playCard3dIntro(card);

    let frame = 0;
    let lastEvent = null;
    let resetTimer = 0;
    const capturePointer = !card.closest(".variant-options");
    const ownsTouchGesture = tiltTouchOwnsGesture(card);
    const reset = (delay = 0) => {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      lastEvent = null;
      if (ownsTouchGesture) document.body.classList.remove("tilt-gesture-active");
      if (resetTimer) window.clearTimeout(resetTimer);
      const run = () => {
        resetTimer = 0;
        resetTiltCard(card);
      };
      if (delay > 0) {
        resetTimer = window.setTimeout(run, delay);
        return;
      }
      run();
    };
    const schedule = (event) => {
      if (event.isPrimary === false) return;
      if (resetTimer) {
        window.clearTimeout(resetTimer);
        resetTimer = 0;
      }
      lastEvent = event;
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        if (lastEvent) updateTiltCard(card, lastEvent);
      });
    };

    card.addEventListener("pointerenter", (event) => {
      if (event.pointerType === "mouse") schedule(event);
    });
    card.addEventListener("pointermove", (event) => {
      if (ownsTouchGesture && card.dataset.tiltActive === "true") preventTiltPageScroll(card, event);
      if (event.pointerType === "mouse" || card.dataset.tiltActive === "true") schedule(event);
    });
    card.addEventListener("pointerdown", (event) => {
      if (event.isPrimary === false || !tiltMotionAllowed()) return;
      preventTiltPageScroll(card, event);
      if (ownsTouchGesture && event.pointerType === "touch") document.body.classList.add("tilt-gesture-active");
      card.dataset.tiltActive = "true";
      schedule(event);
      if (!capturePointer) return;
      try {
        card.setPointerCapture?.(event.pointerId);
      } catch {
        // Certains navigateurs refusent la capture si le pointeur est deja libere.
      }
    });
    card.addEventListener("pointerup", (event) => {
      preventTiltPageScroll(card, event);
      try {
        if (capturePointer && card.hasPointerCapture?.(event.pointerId)) card.releasePointerCapture?.(event.pointerId);
      } catch {
        // Certains navigateurs relachent automatiquement la capture au pointerup.
      }
      reset(event.pointerType === "touch" ? 450 : 0);
    });
    card.addEventListener("pointercancel", () => reset());
    card.addEventListener("pointerleave", (event) => {
      if (event.pointerType === "mouse" || card.dataset.tiltActive !== "true") reset();
    });
  });
}

function setImagePreviewTilt(enabled) {
  if (!imagePreview) return;
  // Le cadre scan/camera doit rester un preview stable. L'effet 3D est reserve
  // aux cartes de la collection et aux comparaisons, pas a la zone de capture.
  imagePreview.removeAttribute("data-tilt-card");
  delete imagePreview.dataset.tiltActive;
  imagePreview.classList.remove("is-tilting");
}

function bindImageFallbacks(root = document) {
  root.querySelectorAll("img[data-fallback]").forEach((img) => {
    img.addEventListener(
      "error",
      () => {
        const fallback = img.dataset.fallback || "TCG";
        const replacement = document.createElement("span");
        replacement.className = "image-fallback-label";
        replacement.textContent = fallback;
        img.replaceWith(replacement);
      },
      { once: true }
    );
  });
  bindTiltCards(root);
}

tiltMotionQuery?.addEventListener?.("change", () => {
  tiltCardsIn(document).forEach(resetTiltCard);
});

function switchView(view) {
  if (view !== "scan") stopCameraStream({ resetPreview: true });
  state.activeView = view;
  appViews.forEach((node) => {
    const isActive = node.dataset.view === view;
    node.hidden = !isActive;
    node.classList.toggle("active", isActive);
  });
  tabButtons.forEach((button) => {
    const isActive = button.dataset.viewTarget === view;
    button.classList.toggle("active", isActive);
    button.setAttribute("aria-selected", String(isActive));
  });
}

function setScanStage(stage) {
  if (stage !== "capture") stopCameraStream({ resetPreview: true });
  state.scanStage = stage;
  scanStages.forEach((node) => {
    const isActive = node.dataset.scanStage === stage;
    node.hidden = !isActive;
    node.classList.toggle("active", isActive);
  });
  renderScanProgress();
  syncMatchDrawer();
}

function syncMatchDrawer() {
  if (!matchDrawer) return;
  matchDrawer.hidden = state.scanStage === "result" && Boolean(state.selectedMatchId);
}

function itemEstimatedValue(item) {
  const value = Number(item?.userCard?.estimatedValue);
  return Number.isFinite(value) ? value : 0;
}

function itemPurchaseValue(item) {
  const purchase = Number(item?.userCard?.purchasePrice);
  const quantity = Number(item?.userCard?.quantity || 1);
  if (!Number.isFinite(purchase)) return 0;
  return purchase * (Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
}

function itemCurrency(item) {
  return item?.userCard?.estimatedValueCurrency || item?.latestSnapshot?.currency || "EUR";
}

function sourceLabel(item) {
  const provider = item?.latestSnapshot?.provider || item?.card?.provider || "manual";
  const sourceCurrency = item?.latestSnapshot?.sourceCurrency;
  if (sourceCurrency && sourceCurrency !== "EUR") {
    return `${provider} converti EUR`;
  }
  if (provider === "pokemon_tcg_api") {
    return "PokemonTCG EUR";
  }
  if (provider === "scryfall") return "Scryfall";
  if (provider === "ygoprodeck") return "YGOPRODeck";
  if (provider === "lorcast") return "Lorcast";
  if (provider === "onepiece_official") return "One Piece officiel";
  if (provider === "onepiece_known_prints") return "Variante One Piece locale";
  if (provider === "openai_web_search") return "Web_search OpenAI";
  if (provider === "web_only") return "Estimation web";
  if (provider === "manual") return "Manuel";
  return provider;
}

function confidenceLabel(value) {
  if (value === "high") return "confiance haute";
  if (value === "medium") return "confiance moyenne";
  return "confiance basse";
}

function matchStatusLabel(match) {
  if (match?.matchStatus === "confirmed") return "Confirme";
  if (match?.matchStatus === "review") return "A verifier";
  if (match?.matchStatus === "weak") return "Faible";
  return confidence(match?.confidence);
}

function matchEvidenceLabel(match) {
  const values = Array.isArray(match?.matchDiagnostics?.evidence) ? match.matchDiagnostics.evidence : [];
  if (!values.length) return "";
  return values
    .slice(0, 3)
    .map((value) =>
      String(value)
        .replace(/_/g, " ")
        .replace(/\b\w/g, (letter) => letter.toUpperCase())
    )
    .join(", ");
}

function conditionLabel(value) {
  const labels = {
    mint: "Mint",
    near_mint: "Near mint",
    excellent: "Excellent",
    good: "Good",
    light_played: "Light played",
    played: "Played",
    poor: "Poor"
  };
  return labels[value] || "Non renseigne";
}

function setCondition(value) {
  const field = form.elements.condition;
  if (!field) return;
  field.value = value;
  if (conditionLabelNode) conditionLabelNode.textContent = conditionLabelText(value);
  conditionButtons.forEach((button) => {
    button.classList.toggle("active", button.dataset.condition === value);
  });
  if (state.priceReview) {
    state.priceReview = null;
    state.lastEstimateAt = null;
    renderPriceReview();
    renderResultCardScreen();
  }
}

function handleFormEdit(event) {
  const name = event.target?.name;
  if (!name) return;
  if (["game", "name", "setCode", "collectorNumber", "language", "isFoil"].includes(name)) {
    state.matchSearchSignature = null;
  }
  if (["condition", "language", "isFoil", "quantity", "manualPrice"].includes(name) && state.priceReview) {
    state.priceReview = null;
    state.lastEstimateAt = null;
    renderPriceReview();
    renderResultCardScreen();
  }
}

function conditionLabelText(value) {
  return conditionLabel(value);
}

function gameLabel(value) {
  if (value === "pokemon") return "Pokemon";
  if (value === "mtg") return "Magic";
  if (value === "yugioh") return "Yu-Gi-Oh!";
  if (value === "lorcana") return "Lorcana";
  if (value === "one_piece") return "One Piece";
  if (value === "star_wars_unlimited") return "Star Wars Unlimited";
  if (value === "flesh_and_blood") return "Flesh and Blood";
  if (value === "dragon_ball") return "Dragon Ball";
  return "Autre";
}

function incrementGroup(map, key, value = 1) {
  map.set(key, (map.get(key) || 0) + value);
}

function renderBreakdown(container, entries, total, formatter = (value) => String(value)) {
  if (!container) return;
  if (!entries.length || total <= 0) {
    container.innerHTML = '<div class="empty-line compact">Aucune donnee.</div>';
    return;
  }
  container.innerHTML = entries
    .map(([label, value]) => {
      const percent = Math.max(4, Math.round((value / total) * 100));
      return `
        <article class="breakdown-row">
          <div>
            <strong>${escapeHtml(label)}</strong>
            <span>${escapeHtml(formatter(value))}</span>
          </div>
          <div class="bar-track" aria-hidden="true"><span style="width: ${percent}%"></span></div>
        </article>
      `;
    })
    .join("");
}

function catalogStats(items) {
  const games = new Map();
  const sources = new Map();
  const conditions = new Map();
  let totalValue = 0;
  let purchaseValue = 0;
  let estimatedRows = 0;
  let copies = 0;

  for (const item of items) {
    const quantity = Number(item.userCard.quantity || 1);
    const safeQuantity = Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    const estimated = itemEstimatedValue(item);
    totalValue += estimated;
    purchaseValue += itemPurchaseValue(item);
    copies += safeQuantity;
    if (estimated > 0) estimatedRows += 1;
    incrementGroup(games, gameLabel(item.card.game), safeQuantity);
    incrementGroup(sources, sourceLabel(item), 1);
    incrementGroup(conditions, conditionLabel(item.userCard.condition), safeQuantity);
  }

  return {
    totalValue,
    purchaseValue,
    estimatedRows,
    copies,
    averageValue: items.length ? totalValue / items.length : 0,
    games: Array.from(games.entries()).sort((a, b) => b[1] - a[1]),
    sources: Array.from(sources.entries()).sort((a, b) => b[1] - a[1]),
    conditions: Array.from(conditions.entries()).sort((a, b) => b[1] - a[1])
  };
}

function selectedMatch() {
  return state.matches.find((match) => match.providerCardId === state.selectedMatchId) || null;
}

function manualMatch() {
  const current = formState();
  const name = current.name || "Carte manuelle";
  return {
    provider: "manual",
    providerCardId: `manual:${name}:${current.setCode}:${current.collectorNumber}`,
    game: current.game,
    name,
    setCode: current.setCode || undefined,
    collectorNumber: current.collectorNumber || undefined,
    confidence: 0.5
  };
}

function applyDetection(detection) {
  const game = detection.game === "unknown" ? "other" : detection.game;
  setFormValue("game", game);
  setFormValue("name", detection.name);
  setFormValue("setCode", detection.setCode);
  setFormValue("collectorNumber", detection.collectorNumber);
  setFormValue("language", detection.language);
  form.elements.isFoil.checked = Boolean(detection.isFoil);
}

function splitCollectorNumber(value) {
  const raw = String(value || "").trim();
  if (!raw) return { collectorNumber: undefined, setSize: undefined };
  const match = raw.match(/^([^/]+?)\s*\/\s*(\d{1,4})$/);
  if (!match) return { collectorNumber: raw, setSize: undefined };
  return {
    collectorNumber: match[1].trim(),
    setSize: match[2] ? Number(match[2]) : undefined
  };
}

function buildSearchPayload(current = formState(), options = {}) {
  const detection = state.detectedCard || {};
  const collector = splitCollectorNumber(current.collectorNumber || detection.collectorNumber);
  const searchNames = Array.isArray(detection.searchNames)
    ? detection.searchNames.map((value) => String(value || "").trim()).filter(Boolean)
    : [];
  return {
    game: current.game,
    name: current.name,
    nameEn: detection.nameEn || undefined,
    searchNames: searchNames.length ? searchNames : undefined,
    setCode: current.setCode || detection.setCode || undefined,
    setName: detection.setName || undefined,
    collectorNumber: collector.collectorNumber,
    setSize: collector.setSize,
    language: current.language,
    isFoil: current.isFoil,
    rarity: detection.rarity || undefined,
    artDescription: detection.artDescription || undefined,
    visualVariant: detection.visualVariant || undefined,
    illustrator: detection.illustrator || undefined,
    printedCode: detection.printedCode || detection.collectorNumber || undefined,
    copyrightLine: detection.copyrightLine || undefined,
    frameLanguage: detection.frameLanguage || detection.language || undefined,
    specialStamp: detection.specialStamp || undefined,
    borderStyle: detection.borderStyle || undefined,
    hp: detection.hp || undefined,
    pokedexNumber: detection.pokedexNumber || undefined,
    cardType: detection.cardType || undefined,
    stage: detection.stage || undefined,
    attackNames: Array.isArray(detection.attackNames) ? detection.attackNames : undefined,
    searchQueries: Array.isArray(detection.searchQueries) ? detection.searchQueries : undefined,
    fast: Boolean(options.fast)
  };
}

function searchSignature(payload) {
  return JSON.stringify({
    game: payload.game,
    name: payload.name,
    nameEn: payload.nameEn || "",
    setCode: payload.setCode || "",
    setName: payload.setName || "",
    collectorNumber: payload.collectorNumber || "",
    setSize: payload.setSize || "",
    language: payload.language || "",
    isFoil: Boolean(payload.isFoil),
    rarity: payload.rarity || "",
    artDescription: payload.artDescription || "",
    visualVariant: payload.visualVariant || "",
    illustrator: payload.illustrator || "",
    printedCode: payload.printedCode || "",
    specialStamp: payload.specialStamp || "",
    borderStyle: payload.borderStyle || "",
    hp: payload.hp || "",
    pokedexNumber: payload.pokedexNumber || "",
    cardType: payload.cardType || "",
    stage: payload.stage || "",
    attackNames: Array.isArray(payload.attackNames) ? payload.attackNames.join("|") : ""
  });
}

function renderDetectedSummary() {
  if (!detectedSummary) return;
  const current = formState();
  const detection = state.detectedCard;
  const match = selectedMatch();
  if (!detection) {
    detectedSummary.innerHTML = `
      <article class="detected-card manual">
        <span class="stage-kicker">Saisie manuelle</span>
        <strong>Complete les champs pour rechercher la correspondance API.</strong>
        <p>Le match exact sera propose avant l'enregistrement.</p>
      </article>
    `;
    if (confirmMatchButton) confirmMatchButton.disabled = false;
    return;
  }
  const userImage = state.imageDataUrl
    ? `<img src="${escapeHtml(state.imageDataUrl)}" alt="Photo scannee" />`
    : "<span>Photo non disponible</span>";
  const providerImage = match?.imageUrl
    ? `<img src="${escapeHtml(cardImageSrc(match.imageUrl))}" alt="${escapeHtml(match.displayName || match.name)}" />`
    : "<span>Choisis une variante</span>";
  const candidates = validationCandidateMatches();
  const variantPicker =
    candidates.length > 1 || (!match && candidates.length > 0)
      ? `
        <section class="variant-picker" aria-label="Variantes officielles">
          <div>
            <span class="stage-kicker">Choix du match</span>
            <strong>${escapeHtml(candidates.length)} proposition(s) a comparer</strong>
            <p>Compare l'image, le numero, l'extension, la rarete et l'illustrateur avant l'estimation.</p>
          </div>
          <div class="variant-options">
            ${candidates
              .map((candidate, index) => {
                const active = candidate.providerCardId === state.selectedMatchId;
                const label = [candidate.displayName || candidate.name, candidate.collectorNumber, candidate.setName || candidate.setCode]
                  .filter(Boolean)
                  .join(" - ");
                const image = candidate.imageUrl
                  ? `<img src="${escapeHtml(cardImageSrc(candidate.imageUrl))}" alt="${escapeHtml(candidate.displayName || candidate.name)}" data-fallback="${escapeHtml(label)}" loading="lazy" />`
                  : `<span>${escapeHtml(gameLabel(candidate.game))}</span>`;
                const detailRows = [
                  ["Statut", matchStatusLabel(candidate)],
                  ["Preuves", matchEvidenceLabel(candidate)],
                  ["No", candidate.collectorNumber],
                  ["PV", candidate.hp],
                  ["Dex", Array.isArray(candidate.nationalPokedexNumbers) ? candidate.nationalPokedexNumbers.join(", ") : ""],
                  ["Type", [candidate.supertype, ...(Array.isArray(candidate.subtypes) ? candidate.subtypes : [])].filter(Boolean).join(" / ")],
                  ["Set", candidate.setName || candidate.setCode],
                  ["Rarete", candidate.rarity],
                  ["Illus.", candidate.illustrator],
                  ["Score", confidence(candidate.matchScore ?? candidate.confidence)]
                ]
                  .filter(([, value]) => value)
                  .slice(0, 8)
                  .map(([key, value]) => `<span><b>${escapeHtml(key)}</b>${escapeHtml(value)}</span>`)
                  .join("");
                return `
                  <button type="button" class="${active ? "active" : ""}" data-select-detected-match="${escapeHtml(candidate.providerCardId)}" aria-pressed="${active ? "true" : "false"}">
                    <em>${active ? "Selection" : `Option ${index + 1}`}</em>
                    <span class="variant-card-art" data-tilt-card>${image}</span>
                    <small>${escapeHtml(label)}</small>
                    <div class="variant-details">${detailRows}</div>
                  </button>
                `;
              })
              .join("")}
          </div>
        </section>
      `
      : "";
  detectedSummary.innerHTML = `
    <article class="detected-card match-status-card">
      <div>
        <span class="stage-kicker">Correspondance</span>
        <strong>${escapeHtml(match?.displayName || match?.name || detection.name || current.name || "Nom non lu")}</strong>
        <p>${escapeHtml([gameLabel(current.game), match?.setName || detection.setName || current.setCode, match?.collectorNumber || current.collectorNumber].filter(Boolean).join(" - ") || "Reference a verifier")}</p>
      </div>
      <div class="confidence-ring">${escapeHtml(confidence(match?.confidence || detection.confidence))}</div>
    </article>
    <section class="comparison-panel">
      <figure>
        <div data-tilt-card>${userImage}</div>
        <figcaption>Photo prise</figcaption>
      </figure>
      <figure>
        <div data-tilt-card>${providerImage}</div>
        <figcaption>${match ? "Match selectionne" : "Comparaison provider"}</figcaption>
      </figure>
    </section>
    ${
      detection.artDescription
        ? `<article class="detected-card manual"><span class="stage-kicker">Indice visuel IA</span><p>${escapeHtml(detection.artDescription)}</p></article>`
        : ""
    }
    ${variantPicker}
  `;
  bindImageFallbacks(detectedSummary);
  if (confirmMatchButton) {
    confirmMatchButton.disabled = state.matches.length > 0 && !state.selectedMatchId;
  }
}

function renderResultCardScreen() {
  if (!resultCardScreen) return;
  const match = selectedMatch();
  const current = formState();
  if (!match) {
    resultCardScreen.innerHTML = `
      <article class="card-screen-empty">
        <strong>Choisis une variante avant l'estimation</strong>
        <p>Quand plusieurs prints partagent le meme nom et le meme numero, ValeoCard attend ton choix visuel.</p>
      </article>
    `;
    return;
  }

  const providerImage = cardImageSrc(match.imageUrl) || "";
  const userImage = state.imageDataUrl || "";
  const ref = [match.setName || match.setCode, match.collectorNumber, match.variantLabel, match.rarity].filter(Boolean).join(" - ");
  const apiQuote = state.priceReview?.api?.quote || null;
  const webQuote = state.priceReview?.web?.quote || null;
  const apiValue = Number(apiQuote?.estimatedValue);
  const webValue = Number(webQuote?.estimatedValue);
  const hasApiValue = Number.isFinite(apiValue) && apiValue > 0;
  const hasWebValue = Number.isFinite(webValue) && webValue > 0;
  const primaryValue = hasApiValue ? apiValue : hasWebValue ? webValue : null;
  const primaryCurrency = hasApiValue ? apiQuote.currency : hasWebValue ? webQuote.currency : "EUR";

  resultCardScreen.innerHTML = `
    <article class="analysis-match-banner">
      <div>
        <span class="stage-kicker">Correspondance retenue</span>
        <strong>${escapeHtml(match.displayName || match.name)}</strong>
        <p>${escapeHtml([gameLabel(match.game), ref || "Reference non renseignee", match.provider].filter(Boolean).join(" - "))}</p>
      </div>
      <div class="analysis-confidence">${escapeHtml(confidence(match.confidence))}</div>
    </article>
    <article class="card-detail">
      <div class="card-detail-art" data-tilt-card>
        ${providerImage ? `<img src="${escapeHtml(providerImage)}" alt="${escapeHtml(match.displayName || match.name)}" data-fallback="${escapeHtml(gameLabel(match.game))}" />` : `<span>${escapeHtml(gameLabel(match.game))}</span>`}
      </div>
      <div class="card-detail-body">
        <span class="stage-kicker">${escapeHtml(gameLabel(match.game))}</span>
        <h3>${escapeHtml(match.displayName || match.name)}</h3>
        <p>${escapeHtml(ref || "Reference non renseignee")}</p>
        <div class="detail-metrics">
          <div><span>Estimation</span><strong>${primaryValue === null ? "Indispo" : currency(primaryValue, primaryCurrency)}</strong></div>
          <div><span>Etat</span><strong>${escapeHtml(conditionLabel(current.condition))}</strong></div>
          <div><span>Analyse</span><strong>${escapeHtml(formatDateTime(state.lastEstimateAt))}</strong></div>
        </div>
        <div class="tag-row">
          <span>${escapeHtml(String(current.language || "n/a").toUpperCase())}</span>
          <span>${current.isFoil ? "Foil / holo" : "Standard"}</span>
          <span>${escapeHtml(match.provider)}</span>
        </div>
      </div>
    </article>
    ${
      userImage
        ? `<section class="analysis-media-grid">
            <figure><div class="analysis-card-art" data-tilt-card><img src="${escapeHtml(userImage)}" alt="Photo prise" /></div><figcaption>Photo prise</figcaption></figure>
            <figure><div class="analysis-card-art" data-tilt-card>${providerImage ? `<img src="${escapeHtml(providerImage)}" alt="${escapeHtml(match.displayName || match.name)}" data-fallback="${escapeHtml(gameLabel(match.game))}" />` : `<span>${escapeHtml(gameLabel(match.game))}</span>`}</div><figcaption>Carte retenue</figcaption></figure>
          </section>`
        : ""
    }
  `;
  bindImageFallbacks(resultCardScreen);
}

async function playBinderAddAnimation(match) {
  const target = document.querySelector('[data-view-target="catalog"]');
  const startNode =
    document.querySelector(".card-detail-art") ||
    document.querySelector(".comparison-panel figure:first-child div") ||
    document.querySelector(".card-result.selected .card-art") ||
    imagePreview;
  if (!target || !startNode || !document.body.animate) return;

  const start = startNode.getBoundingClientRect();
  const end = target.getBoundingClientRect();
  const image = state.imageDataUrl || cardImageSrc(match?.imageUrl) || "";
  const card = document.createElement("div");
  card.className = "binder-fly-card";
  card.style.left = `${start.left + start.width / 2 - 48}px`;
  card.style.top = `${start.top + start.height / 2 - 68}px`;
  card.innerHTML = image
    ? `<img src="${escapeHtml(image)}" alt="">`
    : `<span>${escapeHtml(gameLabel(match?.game || "other"))}</span>`;
  document.body.append(card);
  target.classList.add("binder-target-pulse");

  const deltaX = end.left + end.width / 2 - (start.left + start.width / 2);
  const deltaY = end.top + end.height / 2 - (start.top + start.height / 2);
  try {
    await card
      .animate(
        [
          { transform: "translate3d(0, 0, 0) scale(1) rotate(0deg)", opacity: 1, filter: "brightness(1.15)" },
          { transform: `translate3d(${deltaX * 0.45}px, ${deltaY * 0.25 - 80}px, 0) scale(1.08) rotate(6deg)`, opacity: 1 },
          { transform: `translate3d(${deltaX}px, ${deltaY}px, 0) scale(0.22) rotate(-10deg)`, opacity: 0.15, filter: "brightness(1.8)" }
        ],
        { duration: 850, easing: "cubic-bezier(.2,.84,.2,1)", fill: "forwards" }
      )
      .finished;
  } catch {
    // Animation interrompue: l'ajout reste valide.
  } finally {
    card.remove();
    target.classList.remove("binder-target-pulse");
  }
}

async function readSelectedImage(file) {
  if (!file) {
    stopCameraStream({ resetPreview: true });
    state.imageDataUrl = null;
    state.imageSource = null;
    imagePreview.classList.remove("has-image", "has-error");
    imagePreview.innerHTML = emptyPreviewHtml();
    setImagePreviewTilt(false);
    updateDetectButtonState();
    return;
  }
  if (file.size > 10 * 1024 * 1024) {
    imageInput.value = "";
    state.imageDataUrl = null;
    state.imageSource = null;
    imagePreview.classList.remove("has-image");
    imagePreview.classList.add("has-error");
    imagePreview.innerHTML = scannerPreviewHtml({
      title: "Image trop lourde",
      detail: "Choisis une photo de moins de 10 Mo.",
      status: "Photo refusee",
      mode: "error"
    });
    setImagePreviewTilt(false);
    updateDetectButtonState();
    showNotice("Image trop lourde pour le MVP. Choisis une image de moins de 10 Mo.", "error");
    return;
  }

  stopCameraStream();
  state.imageDataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("Lecture de l'image impossible."));
    reader.readAsDataURL(file);
  });
  state.imageSource = "gallery";
  imagePreview.classList.add("has-image");
  imagePreview.classList.remove("has-error");
  imagePreview.innerHTML = scannerPreviewHtml({
    imageHtml: `<img src="${state.imageDataUrl}" alt="Photo de carte" />`,
    title: "Photo chargee",
    detail: "Lance la detection IA.",
    status: "Photo prete",
    mode: "ready"
  });
  setImagePreviewTilt(false);
  aiSummary.textContent = `${file.name} pret pour detection IA.`;
  updateDetectButtonState();
  imageInput.value = "";
}

function resetScanForNextCard() {
  stopCameraStream();
  state.matches = [];
  state.selectedMatchId = null;
  state.imageDataUrl = null;
  state.imageSource = null;
  state.priceReview = null;
  state.lastDetectionSource = null;
  state.lastAttemptedQueries = [];
  state.detectedCard = null;
  state.lastEstimateAt = null;
  imageInput.value = "";
  imagePreview.classList.remove("has-image", "has-error");
  imagePreview.innerHTML = emptyPreviewHtml();
  setImagePreviewTilt(false);
  updateDetectButtonState();
  aiSummary.textContent = "Ajoute une photo pour extraire automatiquement le nom, le jeu, le numero et la langue.";
  setFormValue("name", "");
  setFormValue("setCode", "");
  setFormValue("collectorNumber", "");
  setFormValue("manualPrice", "");
  setFormValue("purchasePrice", "");
  setFormValue("quantity", "1");
  renderResults();
  renderPriceReview();
  renderAttemptedQueries();
  renderDetectedSummary();
  renderResultCardScreen();
  setScanStage("capture");
}

async function detectCard() {
  if (state.detectionRunning) return;
  if (!state.imageDataUrl) {
    showNotice("Ajoute une photo avant de lancer la detection IA.", "error");
    return;
  }

  const current = formState();
  state.detectionRunning = true;
  hideNotice();
  updateDetectButtonState({ loading: true });
  if (detectionStatus) detectionStatus.textContent = "Lecture IA de la photo.";
  setScanStage("detecting");
  try {
    const payload = await api("/api/ai/detect-card", {
      method: "POST",
      body: JSON.stringify({
        imageDataUrl: state.imageDataUrl,
        languageHint: current.language
      })
    });

    applyDetection(payload.detection);
    state.detectedCard = payload.detection;
    state.matches = [];
    state.selectedMatchId = null;
    state.priceReview = null;
    state.lastEstimateAt = null;
    state.matchSearchSignature = null;
    state.lastDetectionSource = "ai";
    renderResults();
    renderPriceReview();
    renderDetectedSummary();
    renderResultCardScreen();
    renderNetwork(payload.networkEvents);
    state.lastAttemptedQueries = [];
    renderAttemptedQueries();
    aiSummary.textContent = [
      payload.detection.name || "Nom non lu",
      payload.detection.collectorNumber ? `numero ${payload.detection.collectorNumber}` : "",
      payload.detection.visualVariant ? `variante ${payload.detection.visualVariant}` : "",
      `confiance ${confidence(payload.detection.confidence)}`
    ]
      .filter(Boolean)
      .join(" - ");
    if (detectionStatus) detectionStatus.textContent = "Recherche d'une image de comparaison dans le catalogue.";
    try {
      const searchPayload = buildSearchPayload(formState(), { fast: true });
      const matchPayload = await api("/api/prices/search", {
        method: "POST",
        body: JSON.stringify(searchPayload)
      });
      state.matches = matchPayload.matches || [];
      state.selectedMatchId = shouldAutoSelectMatch(state.matches);
      state.matchSearchSignature = searchSignature(searchPayload);
      renderResults();
      renderNetwork(matchPayload.networkEvents);
    } catch (matchError) {
      state.matches = [];
      state.selectedMatchId = null;
      state.matchSearchSignature = null;
      showNotice(`Detection IA terminee, mais image provider introuvable: ${matchError.message}`, "error");
    }
    renderDetectedSummary();
    renderResultCardScreen();
    refreshQuotas().catch(() => undefined);
    if (!notice.hidden && notice.classList.contains("error")) return;
    if (state.matches.length === 1 && state.selectedMatchId) {
      if (detectionStatus) detectionStatus.textContent = "Match unique trouve. Estimation automatique avec l'etat par defaut.";
      showNotice("Carte detectee. Estimation automatique en cours avec l'etat Near mint, modifiable apres resultat.");
      await searchCards();
      return;
    }
    setScanStage(state.matches.length ? "verify" : "condition");
    if (state.matches.length > 1 && !state.selectedMatchId) {
      showNotice("Detection IA terminee. Plusieurs variantes existent : choisis le visuel exact avant estimation.");
    } else if (state.matches.length === 1) {
      showNotice("Detection IA terminee. Verifie le visuel propose avant de renseigner l'etat.");
    } else {
      showNotice("Detection IA terminee. Choisis l'etat avant estimation.");
    }
  } catch (error) {
    setScanStage("capture");
    showNotice(error.message, "error");
  } finally {
    state.detectionRunning = false;
    updateDetectButtonState();
  }
}

function renderAttemptedQueries() {
  const list = state.lastAttemptedQueries || [];
  if (!attemptedPanel) return;
  if (!list.length) {
    attemptedPanel.innerHTML = '<div class="empty-line">Aucune requete tentee.</div>';
    return;
  }
  attemptedPanel.innerHTML = list
    .map((q) => {
      if (typeof q === "string") {
        return `
          <article class="network-row">
            <div>
              <a href="${escapeHtml(q)}" target="_blank" rel="noreferrer">${escapeHtml(shortUrl(q))}</a>
              <div class="small mono">${escapeHtml(q)}</div>
            </div>
          </article>
        `;
      }
      const url = q?.url || JSON.stringify(q);
      const count = q?.count ?? "?";
      const qtext = q?.q || "";
      return `
        <article class="network-row">
          <div>
            <a href="${escapeHtml(url)}" target="_blank" rel="noreferrer">${escapeHtml(shortUrl(url))}</a>
            <div class="small mono">${escapeHtml(qtext)}</div>
            <div class="tiny">Resultats: ${escapeHtml(String(count))}</div>
          </div>
        </article>
      `;
    })
    .join("");
}

async function searchCards() {
  const current = formState();
  if (!current.name) {
    showNotice("Renseigne un nom de carte avant l'estimation.", "error");
    return;
  }
  hideNotice();
  searchButton.disabled = true;
  searchButton.textContent = "Estimation...";
  if (estimationStatus) estimationStatus.textContent = "Recherche du match exact dans le provider TCG.";
  setScanStage("estimating");
  try {
      const searchPayload = buildSearchPayload(current, { fast: true });
    const signature = searchSignature(searchPayload);
    const canReuseMatch = state.matches.length > 0 && state.selectedMatchId && state.matchSearchSignature === signature;
    if (!canReuseMatch) {
      const payload = await api("/api/prices/search", {
        method: "POST",
        body: JSON.stringify(searchPayload)
      });
      state.matches = payload.matches || [];
      state.selectedMatchId = shouldAutoSelectMatch(state.matches);
      state.matchSearchSignature = signature;
      renderNetwork(payload.networkEvents);
    }
    state.priceReview = null;
    state.lastDetectionSource = state.detectedCard ? "ai" : "manual_search";
    state.lastEstimateAt = null;
    renderResults();
    renderDetectedSummary();
    renderPriceReview();
    renderResultCardScreen();
    if (!state.matches.length) {
      setScanStage("condition");
      showNotice("Aucun match provider trouve. Corrige les details ou enregistre une carte manuelle.", "error");
      return;
    }
    if (!state.selectedMatchId) {
      setScanStage("verify");
      showNotice("Plusieurs variantes possibles. Choisis d'abord le visuel exact avant de lancer l'estimation.", "error");
      return;
    }
    if (estimationStatus) estimationStatus.textContent = "Match trouve. Recuperation du prix API et recherche web citee.";
    await runPriceReview({ automatic: true });
    state.lastEstimateAt = new Date().toISOString();
    renderResultCardScreen();
    setScanStage("result");
    showNotice(`${state.matches.length} match(s) disponible(s). Estimation API + web terminee.`);
  } catch (error) {
    setScanStage("condition");
    showNotice(error.message, "error");
  } finally {
    searchButton.disabled = false;
    searchButton.textContent = "Estimer cette carte";
  }
}

async function runPriceReview({ automatic = false } = {}) {
  const match = selectedMatch();
  if (!match) {
    showNotice("Selectionne une carte avant l'estimation web.", "error");
    return;
  }
  const current = formState();
  hideNotice();
  state.priceReview = { status: "loading", automatic };
  renderPriceReview();
  try {
    const quotePromise = api("/api/prices/quote", {
      method: "POST",
      body: JSON.stringify({
        match,
        condition: current.condition,
        language: current.language,
        isFoil: current.isFoil,
        quantity: current.quantity,
        manualPrice: current.manualPrice
      })
    });
    const webPromise = api("/api/prices/web-estimate", {
      method: "POST",
      body: JSON.stringify({
        match,
        condition: current.condition,
        language: current.language,
        isFoil: current.isFoil,
        quantity: current.quantity
      })
    });
    const [apiQuote, webQuote] = await Promise.allSettled([quotePromise, webPromise]);
    state.priceReview = {
      status: "ready",
      automatic,
      api: apiQuote.status === "fulfilled" ? apiQuote.value : null,
      apiError: apiQuote.status === "rejected" ? apiQuote.reason.message : null,
      web: webQuote.status === "fulfilled" ? webQuote.value : null,
      webError: webQuote.status === "rejected" ? webQuote.reason.message : null
    };
    state.lastEstimateAt = new Date().toISOString();
    renderPriceReview();
    renderResultCardScreen();
    renderNetwork([
      ...(state.priceReview.api?.networkEvents || []),
      ...(state.priceReview.web?.networkEvents || [])
    ]);
    refreshQuotas().catch(() => undefined);
  } catch (error) {
    state.priceReview = { status: "error", error: error.message };
    renderPriceReview();
    renderResultCardScreen();
  }
}

async function addMatch(match) {
  if (state.isBusy) return;
  if (!match?.provider || !match.providerCardId || !match.name) {
    showNotice("Match invalide : impossible d'ajouter cette carte.", "error");
    return;
  }
  const current = formState();
  const shouldResumeCamera = state.imageSource === "camera";
  const webReview = state.priceReview?.status === "ready" ? state.priceReview.web || null : null;
  hideNotice();
  state.isBusy = true;
  renderResults();
  try {
    const payload = await api("/api/catalog/user-cards", {
      method: "POST",
      body: JSON.stringify({
        match,
        condition: current.condition,
        language: current.language,
        isFoil: current.isFoil,
        quantity: current.quantity,
        manualPrice: current.manualPrice,
        purchasePrice: current.purchasePrice,
        webQuote: webReview?.quote || null,
        webEstimate: webReview?.estimate || null,
        webCitations: webReview?.citations || []
      })
    });
    renderNetwork(payload.networkEvents);
    await refreshCatalog();
    await playBinderAddAnimation(match);
    const savedValue = Number(payload.quote?.chosenEstimatedValue ?? payload.quote?.estimatedValue);
    const savedCurrency = payload.quote?.chosenCurrency || payload.quote?.currency || "EUR";
    if (!Number.isFinite(savedValue) || savedValue <= 0) {
      showNotice("Carte ajoutee. Aucun prix API disponible : renseigne une valeur manuelle pour l'estimation.");
    } else if (payload.usedWebFallback) {
      showNotice(`Carte ajoutee avec estimation web ${currency(savedValue, savedCurrency)}. Pret pour la suivante.`);
    } else {
      showNotice(`Carte ajoutee avec estimation ${currency(savedValue, savedCurrency)}. Pret pour la suivante.`);
    }
    resetScanForNextCard();
    if (shouldResumeCamera) {
      window.setTimeout(() => {
        startCamera({ keepNotice: true }).catch((error) => showNotice(error.message, "error"));
      }, 350);
    }
  } catch (error) {
    showNotice(error.message, "error");
  } finally {
    state.isBusy = false;
    renderResults();
  }
}

function renderResults() {
  syncMatchDrawer();
  if (!state.matches.length) {
    results.innerHTML = '<div class="empty-state">Lance une recherche ou une detection IA pour voir les cartes candidates.</div>';
    selectionBar.hidden = true;
    selectionActionBar.hidden = true;
    if (priceReviewPanel) priceReviewPanel.hidden = true;
    return;
  }

  results.innerHTML = state.matches
    .map((match) => {
      const selected = match.providerCardId === state.selectedMatchId;
      const variantLabel = matchVariantLabel(match);
      const image = match.imageUrl
        ? `<img src="${escapeHtml(cardImageSrc(match.imageUrl))}" alt="${escapeHtml(match.name)}" data-fallback="${escapeHtml(gameLabel(match.game))}" loading="lazy" />`
        : `<div>${escapeHtml(gameLabel(match.game))}</div>`;
      return `
        <article class="card-result ${selected ? "selected" : ""}" data-select-card="${escapeHtml(match.providerCardId)}" role="button" tabindex="0" aria-pressed="${selected ? "true" : "false"}">
          <button class="select-hit" data-select="${escapeHtml(match.providerCardId)}" aria-label="Selectionner ${escapeHtml(match.displayName || match.name)}">${selected ? "OK " : ""}${confidence(match.confidence)}</button>
          <div class="card-art" data-tilt-card>${image}</div>
          <div class="card-meta">
            <h3>${escapeHtml(match.displayName || match.name)}</h3>
            <p>${escapeHtml([match.setName || match.setCode || "Extension non renseignee", variantLabel !== "Standard" ? variantLabel : ""].filter(Boolean).join(" - "))}</p>
            <dl>
              <div><dt>Numero</dt><dd>${escapeHtml(match.collectorNumber || "-")}</dd></div>
              <div><dt>Rarete</dt><dd>${escapeHtml(match.rarity || "-")}</dd></div>
              <div><dt>Source</dt><dd>${escapeHtml(match.provider)}</dd></div>
            </dl>
          </div>
          <button class="secondary-button" data-select="${escapeHtml(match.providerCardId)}" ${state.isBusy ? "disabled" : ""}>Choisir ce match</button>
        </article>
      `;
    })
    .join("");
  bindImageFallbacks(results);

  const selected = selectedMatch();
  if (!selected) {
    selectionBar.hidden = true;
    selectionActionBar.hidden = true;
    return;
  }

  selectionBar.hidden = state.scanStage === "result";
  selectionBar.innerHTML = state.scanStage === "result"
    ? ""
    : `Match actif : <strong>${escapeHtml(selected.displayName || selected.name)}</strong> via ${escapeHtml(selected.provider)}`;
  selectionActionBar.hidden = false;
  selectionActionName.textContent = selected.displayName || selected.name;
  addSelectedButton.disabled = state.isBusy;
}

function renderPriceReview() {
  if (!priceReviewPanel) return;
  const review = state.priceReview;
  if (!review) {
    priceReviewPanel.hidden = true;
    priceReviewPanel.innerHTML = "";
    return;
  }

  priceReviewPanel.hidden = false;
  if (review.status === "loading") {
    priceReviewPanel.innerHTML = `
      <article class="price-review-card loading">
        <span class="eyebrow">Controle prix automatique</span>
        <h3>API + web_search en cours</h3>
        <p>Valeo compare le prix provider structure avec une recherche web citee.</p>
      </article>
    `;
    return;
  }

  if (review.status === "error") {
    priceReviewPanel.innerHTML = `<div class="empty-line compact">${escapeHtml(review.error || "Erreur estimation.")}</div>`;
    return;
  }

  const apiQuote = review.api?.quote || null;
  const webQuote = review.web?.quote || null;
  const webEstimate = review.web?.estimate || {};
  const citations = Array.isArray(review.web?.citations) ? review.web.citations : [];
  const apiValue = Number(apiQuote?.estimatedValue);
  const webValue = Number(webQuote?.estimatedValue);
  const hasApi = Number.isFinite(apiValue) && apiValue > 0;
  const hasWeb = Number.isFinite(webValue) && webValue > 0;
  const usableCitations = hasWeb ? citations : [];
  const diff = hasApi && hasWeb ? webValue - apiValue : null;
  const diffPercent = diff !== null && apiValue > 0 ? Math.round((diff / apiValue) * 100) : null;
  const aligned = diffPercent !== null ? Math.abs(diffPercent) <= 25 : false;
  const explanation = priceDifferenceExplanation({ hasApi, hasWeb, diffPercent, webEstimate });

  priceReviewPanel.innerHTML = `
    <article class="price-review-card ${aligned ? "aligned" : "needs-check"}">
      <div class="review-heading">
        <div>
          <span class="eyebrow">Controle prix automatique</span>
          <h3>${aligned ? "Prix coherents" : "Prix a verifier"}</h3>
        </div>
        <strong>${diffPercent === null ? "n/a" : `${diffPercent > 0 ? "+" : ""}${diffPercent}%`}</strong>
      </div>
      <div class="price-compare-grid">
        <section>
          <span>API marche</span>
          <strong>${hasApi ? currency(apiValue, apiQuote.currency) : "Indispo"}</strong>
          <small>${escapeHtml(apiSourceText(review.api))}</small>
        </section>
        <section>
          <span>Web cite</span>
          <strong>${hasWeb ? currency(webValue, webQuote.currency) : "Indispo"}</strong>
          <small>${escapeHtml(confidenceLabel(webEstimate.confidence))}</small>
        </section>
      </div>
      <p>${escapeHtml(explanation)}</p>
      ${renderWebWarnings(webEstimate)}
      ${renderCitationDrawer(usableCitations)}
    </article>
  `;
}

function renderCitationDrawer(citations) {
  if (!citations.length) return '<div class="citation-list compact"><span>Aucune citation exploitable.</span></div>';
  return `
    <details class="citation-drawer">
      <summary>Sources web (${citations.length})</summary>
      <div class="citation-list">
        ${citations
          .slice(0, 6)
          .map(
            (citation) =>
              `<a href="${escapeHtml(citation.url)}" target="_blank" rel="noreferrer">${escapeHtml(citation.title || shortUrl(citation.url))}</a>`
          )
          .join("")}
      </div>
    </details>
  `;
}

function apiSourceText(payload) {
  const provider = payload?.quote?.prices?.provider || payload?.provider || "provider";
  const sourceCurrency = payload?.quote?.prices?.sourceCurrency;
  if (sourceCurrency && sourceCurrency !== "EUR") return `${provider} converti en EUR via ECB`;
  if (provider === "pokemon_tcg_api") return "PokemonTCG / Cardmarket EUR";
  if (provider === "scryfall") return "Scryfall EUR";
  return provider;
}

function priceDifferenceExplanation({ hasApi, hasWeb, diffPercent, webEstimate }) {
  if (!hasApi && !hasWeb) return "Aucune source n'a donne un prix exploitable. Saisis un prix manuel.";
  if (!hasApi) return "Le provider structure ne donne pas de prix; le web donne seulement une indication a verifier.";
  if (!hasWeb) return "Le provider structure donne un prix, mais le web n'a pas assez de preuves citees.";
  if (Math.abs(diffPercent) <= 25) return "Les deux sources sont proches. Le prix API peut etre utilise comme base, avec controle visuel du match.";
  if (diffPercent > 25) return "Le web est nettement plus haut que l'API. Verifie langue, etat, finition, ventes terminees et carte gradee.";
  return "Le web est nettement plus bas que l'API. Verifie si les sources web concernent la meme edition ou des annonces incompletes.";
}

function renderWebWarnings(estimate) {
  const warnings = Array.isArray(estimate?.warnings) ? estimate.warnings : [];
  if (!warnings.length) return "";
  return `<ul class="web-warnings">${warnings.map((warning) => `<li>${escapeHtml(warning)}</li>`).join("")}</ul>`;
}

async function refreshCatalog() {
  const payload = await api("/api/catalog");
  state.catalogItems = payload.items || [];
  updateCatalogChrome();
  renderCatalog();
  renderStats();
}

function updateCatalogChrome() {
  const stats = catalogStats(state.catalogItems);
  if (headerCardCount) headerCardCount.textContent = String(state.catalogItems.length);
  if (headerTotalValue) headerTotalValue.textContent = compactCurrency(stats.totalValue, "EUR");
  catalogSummary.textContent = `${state.catalogItems.length} carte(s), ${stats.copies} exemplaire(s), ${compactCurrency(stats.totalValue, "EUR")} estimes.`;
  if (collectionTotalValue) collectionTotalValue.textContent = compactCurrency(stats.totalValue, "EUR");
  if (collectionCardCount) collectionCardCount.textContent = String(stats.copies);
  if (collectionAverageValue) collectionAverageValue.textContent = compactCurrency(stats.averageValue, "EUR");
  renderCatalogControls();
}

function quotaByMetric(metric) {
  return (state.quotas?.quotas || []).find((quota) => quota.metric === metric) || null;
}

function quotaLabel(quota) {
  if (!quota) return "n/a";
  const remaining = Number(quota.remaining);
  const limit = Number(quota.limit);
  if (!Number.isFinite(remaining) || !Number.isFinite(limit)) return "n/a";
  if (quota.metric === "ai_cost_usd") return `${usdCost(Math.max(0, remaining))} / ${usdCost(limit)}`;
  return `${Math.max(0, Math.floor(remaining))} / ${Math.floor(limit)}`;
}

function renderQuotas() {
  const webQuota = quotaByMetric("web_price_estimate");
  const detectionQuota = quotaByMetric("card_detection");
  const costQuota = quotaByMetric("ai_cost_usd");
  const isOwner = state.authUser?.role === "owner" || state.quotas?.user?.plan?.code === "owner";
  if (diagnosticsDrawer) diagnosticsDrawer.hidden = !isOwner;
  if (openCostsButton) {
    openCostsButton.disabled = !isOwner;
    openCostsButton.textContent = isOwner ? "Analyser les couts" : "Reserve owner";
  }
  if (headerQuota) headerQuota.textContent = webQuota ? String(Math.max(0, Math.floor(Number(webQuota.remaining)))) : "--";
  if (headerUserName) {
    headerUserName.textContent =
      state.quotas?.user?.displayName || state.authUser?.displayName || state.currentUserId || "--";
  }
  if (headerPlanName) {
    headerPlanName.textContent = state.quotas?.user?.plan?.name || state.authUser?.plan?.name || "compte";
  }
  if (mobileQuotaStrip) {
    const planName = state.quotas?.user?.plan?.name || "Free";
    const displayName = state.quotas?.user?.displayName || state.authUser?.displayName || state.currentUserId;
    const remaining = webQuota ? Math.max(0, Math.floor(Number(webQuota.remaining))) : "--";
    const stats = catalogStats(state.catalogItems);
    mobileQuotaStrip.innerHTML = `
      <div>
        <span>${escapeHtml(planName)} - ${escapeHtml(displayName)}</span>
        <small>${escapeHtml(String(state.catalogItems.length))} cartes - ${escapeHtml(compactCurrency(stats.totalValue, "EUR"))}</small>
      </div>
      <strong>${escapeHtml(String(remaining))} web restants</strong>
    `;
  }
  refreshScannerQuotaText();
  if (!profileQuotaSummary) return;
  const plan = state.quotas?.user?.plan;
  if (!plan) {
    profileQuotaSummary.innerHTML = "<p>Quotas indisponibles.</p>";
    return;
  }
  profileQuotaSummary.innerHTML = `
    <div class="quota-plan-row">
      <span>Compte actif</span>
      <strong>${escapeHtml(state.quotas?.user?.displayName || state.authUser?.displayName || state.currentUserId)}</strong>
    </div>
    <div class="quota-plan-row">
      <span>Plan</span>
      <strong>${escapeHtml(plan.name || plan.code || "Free")}</strong>
    </div>
    <div class="quota-meter">
      <span>Scans IA</span>
      <strong>${escapeHtml(quotaLabel(detectionQuota))}</strong>
    </div>
    <div class="quota-meter">
      <span>Estimations web</span>
      <strong>${escapeHtml(quotaLabel(webQuota))}</strong>
    </div>
    <div class="quota-meter">
      <span>Budget IA mensuel</span>
      <strong>${escapeHtml(quotaLabel(costQuota))}</strong>
    </div>
  `;
}

async function loadSession() {
  state.authUser = await api("/api/me");
  state.currentUserId = state.authUser.id || state.currentUserId;
  try {
    window.localStorage?.setItem("valeo:userId", state.currentUserId);
  } catch {
    // Storage can be unavailable in private or embedded contexts.
  }
  hideAuthScreen();
  return state.authUser;
}

async function refreshQuotas() {
  state.quotas = await api("/api/quotas");
  renderQuotas();
  return state.quotas;
}

async function refreshAuthenticatedData() {
  await refreshQuotas().catch(() => renderQuotas());
  await refreshCatalog().catch((error) => showNotice(error.message, "error"));
  await refreshAiUsage().catch(() => undefined);
  await refreshNetwork().catch(() => undefined);
}

function renderCatalogControls() {
  catalogGameFilter?.querySelectorAll("[data-catalog-game]").forEach((button) => {
    button.classList.toggle("active", button.dataset.catalogGame === state.catalogGame);
  });
  catalogSort?.querySelectorAll("[data-catalog-sort]").forEach((button) => {
    button.classList.toggle("active", button.dataset.catalogSort === state.catalogSort);
  });
}

function filteredCatalogItems() {
  const query = state.catalogQuery.trim().toLowerCase();
  const game = state.catalogGame;
  const byGame = game === "all" ? state.catalogItems : state.catalogItems.filter((item) => item.card.game === game);
  const items = query
    ? byGame.filter((item) => {
        const haystack = [
          item.card.displayName,
          item.card.name,
          item.card.setName,
          item.card.setCode,
          item.card.collectorNumber,
          item.card.rarity,
          item.userCard.language,
          conditionLabel(item.userCard.condition),
          sourceLabel(item)
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        return haystack.includes(query);
      })
    : [...byGame];

  if (state.catalogSort === "value") {
    return items.sort((a, b) => itemEstimatedValue(b) - itemEstimatedValue(a));
  }
  if (state.catalogSort === "name") {
    return items.sort((a, b) => String(a.card.displayName || a.card.name).localeCompare(String(b.card.displayName || b.card.name), "fr"));
  }
  return items.sort((a, b) => String(b.userCard.createdAt || "").localeCompare(String(a.userCard.createdAt || "")));
}

function renderCatalog() {
  const items = filteredCatalogItems();
  if (!state.catalogItems.length) {
    catalog.innerHTML = '<div class="empty-line">Aucune carte ajoutee pour le moment.</div>';
    return;
  }
  if (!items.length) {
    catalog.innerHTML = '<div class="empty-line">Aucune carte ne correspond au filtre.</div>';
    return;
  }
  catalog.innerHTML = items
    .map((item) => {
      const image = item.card.imageUrl
        ? `<img src="${escapeHtml(cardImageSrc(item.card.imageUrl))}" alt="${escapeHtml(item.card.name)}" data-fallback="${escapeHtml(gameLabel(item.card.game))}" loading="lazy" />`
        : `<span>${escapeHtml(gameLabel(item.card.game))}</span>`;
      const thumb = card3dArtHtml({
        className: "thumb",
        contentHtml: image,
        label: item.card.rarity || gameLabel(item.card.game),
        idle: false
      });
      const source = sourceLabel(item);
      const value = itemEstimatedValue(item);
      const lastUpdate = item.userCard.lastPriceUpdateAt || item.latestSnapshot?.fetchedAt || "date inconnue";
      return `
        <article class="catalog-row binder-pocket" data-open-user-card="${escapeHtml(item.userCard.id)}" role="button" tabindex="0" aria-label="Voir ${escapeHtml(item.card.displayName || item.card.name)}">
          ${thumb}
          <div>
            <h3>${escapeHtml(item.card.displayName || item.card.name)}</h3>
            <p>${escapeHtml([item.card.setName || item.card.setCode || "Extension n/a", item.card.collectorNumber || "n/a", item.card.variantLabel].filter(Boolean).join(" - "))} - ${item.userCard.quantity}x</p>
            <div class="tag-row">
              <span>${escapeHtml(conditionLabel(item.userCard.condition))}</span>
              <span>${escapeHtml(String(item.userCard.language || "n/a").toUpperCase())}</span>
              <span>${item.userCard.isFoil ? "Foil / holo" : "Standard"}</span>
            </div>
          </div>
          <div class="value-block">
            <strong>${value ? currency(value, itemCurrency(item)) : "Non estime"}</strong>
            <span>${escapeHtml(source)}</span>
            <small>${escapeHtml(String(lastUpdate))}</small>
            <button class="delete-card-button" type="button" data-delete-user-card="${escapeHtml(item.userCard.id)}">Supprimer</button>
          </div>
        </article>
      `;
    })
    .join("");
  bindImageFallbacks(catalog);
}

function renderSavedCardDetail(item) {
  if (!savedCardDetail) return;
  if (!item) {
    savedCardDetail.innerHTML = '<div class="empty-line">Carte introuvable dans le classeur.</div>';
    return;
  }
  const value = itemEstimatedValue(item);
  const lastUpdate = item.userCard.lastPriceUpdateAt || item.latestSnapshot?.fetchedAt || item.userCard.createdAt;
  const image = item.card.imageUrl
    ? `<img src="${escapeHtml(cardImageSrc(item.card.imageUrl))}" alt="${escapeHtml(item.card.displayName || item.card.name)}" />`
    : `<span>${escapeHtml(gameLabel(item.card.game))}</span>`;
  const visual = card3dArtHtml({
    className: "saved-card-art",
    contentHtml: image,
    label: item.card.rarity || item.card.setCode || gameLabel(item.card.game),
    intro: true
  });
  const ref = [item.card.setName || item.card.setCode, item.card.collectorNumber, item.card.variantLabel, item.card.rarity].filter(Boolean).join(" - ");
  savedCardDetail.innerHTML = `
    <article class="saved-card-screen">
      <div class="saved-card-visual">
        ${visual}
        <p class="card3d-hint">Touche ou survole la carte pour l'effet 3D.</p>
      </div>
      <div class="saved-card-body">
        <span class="stage-kicker">${escapeHtml(gameLabel(item.card.game))}</span>
        <h3>${escapeHtml(item.card.displayName || item.card.name)}</h3>
        <p>${escapeHtml(ref || "Reference non renseignee")}</p>
        <div class="detail-metrics">
          <div><span>Valeur</span><strong>${value > 0 ? currency(value, itemCurrency(item)) : "Indispo"}</strong></div>
          <div><span>Etat</span><strong>${escapeHtml(conditionLabel(item.userCard.condition))}</strong></div>
          <div><span>Analyse prix</span><strong>${escapeHtml(formatDateTime(lastUpdate))}</strong></div>
        </div>
        <div class="saved-detail-grid">
          <div><span>Source</span><strong>${escapeHtml(sourceLabel(item))}</strong></div>
          <div><span>Langue</span><strong>${escapeHtml(String(item.userCard.language || "n/a").toUpperCase())}</strong></div>
          <div><span>Finition</span><strong>${item.userCard.isFoil ? "Foil / holo" : "Standard"}</strong></div>
          <div><span>Quantite</span><strong>${escapeHtml(String(item.userCard.quantity || 1))}</strong></div>
          <div><span>Prix achat</span><strong>${item.userCard.purchasePrice ? currency(item.userCard.purchasePrice, "EUR") : "Non renseigne"}</strong></div>
          <div><span>Ajout</span><strong>${escapeHtml(formatDateTime(item.userCard.createdAt))}</strong></div>
        </div>
      </div>
    </article>
  `;
  bindImageFallbacks(savedCardDetail);
}

function openSavedCard(userCardId) {
  const item = state.catalogItems.find((entry) => entry.userCard.id === userCardId);
  state.activeSavedCardId = userCardId;
  renderSavedCardDetail(item);
  switchView("card");
}

catalog.addEventListener("click", async (event) => {
  const deleteId = event.target.closest("[data-delete-user-card]")?.dataset.deleteUserCard;
  if (!deleteId) return;
  if (!confirm("Supprimer cette carte du classeur ?")) return;
  try {
    await fetch(`/api/catalog/user-cards/${encodeURIComponent(deleteId)}`, {
      method: "DELETE",
      credentials: "include"
    });
    await refreshCatalog();
    showNotice("Carte supprimee du classeur.");
  } catch (error) {
    showNotice(error.message, "error");
  }
});

catalog.addEventListener("click", (event) => {
  if (event.target.closest("[data-delete-user-card]")) return;
  const openId = event.target.closest("[data-open-user-card]")?.dataset.openUserCard;
  if (openId) openSavedCard(openId);
});

catalog.addEventListener("keydown", (event) => {
  if (event.key !== "Enter" && event.key !== " ") return;
  const openId = event.target.closest("[data-open-user-card]")?.dataset.openUserCard;
  if (!openId) return;
  event.preventDefault();
  openSavedCard(openId);
});

function renderStats() {
  const stats = catalogStats(state.catalogItems);
  const totalRows = state.catalogItems.length;
  if (statsTotalValue) statsTotalValue.textContent = compactCurrency(stats.totalValue, "EUR");
  if (statsEstimatedNote) {
    statsEstimatedNote.textContent = stats.estimatedRows
      ? `${stats.estimatedRows}/${totalRows} ligne(s) avec prix`
      : "Aucune carte valorisee";
  }
  if (statsCardCount) statsCardCount.textContent = String(totalRows);
  if (statsCopyCount) statsCopyCount.textContent = `${stats.copies} exemplaire(s)`;
  if (statsAverageValue) statsAverageValue.textContent = compactCurrency(stats.averageValue, "EUR");
  if (statsPurchaseValue) statsPurchaseValue.textContent = compactCurrency(stats.purchaseValue, "EUR");
  if (statsProfitValue) {
    const diff = stats.totalValue - stats.purchaseValue;
    statsProfitValue.textContent =
      stats.purchaseValue > 0 ? `${diff >= 0 ? "+" : ""}${compactCurrency(diff, "EUR")} vs achat` : "Ajoute tes prix achat";
  }
  renderBreakdown(statsGames, stats.games, stats.copies, (value) => `${value} exemplaire(s)`);
  renderBreakdown(statsSources, stats.sources, Math.max(totalRows, 1), (value) => `${value} ligne(s)`);
  renderBreakdown(statsConditions, stats.conditions, stats.copies, (value) => `${value} exemplaire(s)`);
}

async function refreshAiUsage() {
  const payload = await api("/api/ai-usage/summary");
  state.aiUsage = payload;
  renderAiUsage();
}

function compactNumber(value) {
  return new Intl.NumberFormat("fr-FR").format(Number(value || 0));
}

function renderCostRows(rows, emptyLabel) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return `<div class="empty-line compact">${escapeHtml(emptyLabel)}</div>`;
  }
  return rows
    .slice(0, 8)
    .map(
      (row) => `
        <article class="cost-row">
          <div>
            <strong>${escapeHtml(row.key || "n/a")}</strong>
            <span>${compactNumber(row.calls)} appel(s) - ${compactNumber(row.input_tokens)} in / ${compactNumber(row.output_tokens)} out</span>
          </div>
          <div>
            <strong>${usdCost(row.cost_usd)}</strong>
            <span>${compactNumber(row.web_search_calls)} web search</span>
          </div>
        </article>
      `
    )
    .join("");
}

function renderRecentUsage(logs) {
  if (!Array.isArray(logs) || logs.length === 0) {
    return '<div class="empty-line compact">Aucun appel recent.</div>';
  }
  return logs
    .slice(0, 12)
    .map(
      (log) => `
        <article class="cost-row compact">
          <div>
            <strong>${escapeHtml(log.feature || "unknown")}</strong>
            <span>${escapeHtml(log.model || "unknown")} - ${escapeHtml(formatDateTime(log.created_at))}</span>
          </div>
          <div>
            <strong>${usdCost(log.cost_usd)}</strong>
            <span>${compactNumber(log.input_tokens)} in / ${compactNumber(log.output_tokens)} out</span>
          </div>
        </article>
      `
    )
    .join("");
}

function renderAiUsage() {
  if (!costsSummary) return;
  const usage = state.aiUsage;
  const totals = usage?.totals || null;
  if (!totals || !totals.calls) {
    costsSummary.innerHTML = '<div class="empty-line">Aucun appel OpenAI journalise pour le moment.</div>';
    return;
  }

  costsSummary.innerHTML = `
    <section class="cost-metrics">
      <article>
        <span>Cout total</span>
        <strong>${usdCost(totals.cost_usd)}</strong>
      </article>
      <article>
        <span>Appels</span>
        <strong>${compactNumber(totals.calls)}</strong>
      </article>
      <article>
        <span>Moyen / utilisateur</span>
        <strong>${usdCost(totals.average_cost_per_user_usd)}</strong>
      </article>
      <article>
        <span>Web search</span>
        <strong>${compactNumber(totals.web_search_calls)}</strong>
      </article>
    </section>
    <section class="cost-panels">
      <article>
        <h3>Par fonctionnalite</h3>
        ${renderCostRows(usage.by_feature, "Aucune fonctionnalite.")}
      </article>
      <article>
        <h3>Par modele</h3>
        ${renderCostRows(usage.by_model, "Aucun modele.")}
      </article>
      <article>
        <h3>Par jour</h3>
        ${renderCostRows(usage.by_day, "Aucun jour.")}
      </article>
      <article>
        <h3>Derniers appels</h3>
        ${renderRecentUsage(usage.recent_logs)}
      </article>
    </section>
    ${
      totals.unpriced_calls
        ? `<div class="notice error compact">${compactNumber(totals.unpriced_calls)} appel(s) sans cout calcule: ajoute le tarif modele dans VALEO_OPENAI_PRICING_JSON.</div>`
        : ""
    }
  `;
}

async function refreshNetwork() {
  const payload = await api("/api/network-events");
  renderNetwork(payload.events);
}

function renderNetwork(events) {
  if (!events || events.length === 0) {
    network.innerHTML = '<div class="empty-line">Aucun appel API journalise.</div>';
    return;
  }
  network.innerHTML = events
    .map(
      (event) => `
        <article class="network-row">
          <div class="status-dot ${event.ok ? "ok" : "ko"}"></div>
          <div>
            <strong>${escapeHtml(event.provider)} - ${escapeHtml(event.method)} - ${escapeHtml(event.status || "ERR")}</strong>
            <a href="${escapeHtml(event.url)}" target="_blank" rel="noreferrer">${escapeHtml(shortUrl(event.url))}</a>
            ${event.error ? `<span class="error-text">${escapeHtml(event.error)}</span>` : ""}
          </div>
          <time>${event.durationMs} ms</time>
        </article>
      `
    )
    .join("");
}

results.addEventListener("click", (event) => {
  const addId = event.target.closest("[data-add]")?.dataset.add;
  if (addId) {
    const match = state.matches.find((item) => item.providerCardId === addId);
    if (match) addMatch(match);
    return;
  }

  const selectId = event.target.closest("[data-select]")?.dataset.select || event.target.closest("[data-select-card]")?.dataset.selectCard;
  if (selectId) {
    if (state.scanStage === "result") {
      showNotice("Le match est deja verrouille pour cette estimation. Utilise Modifier l'analyse pour changer de carte.");
      return;
    }
    state.selectedMatchId = selectId;
    state.priceReview = null;
    renderResults();
    renderDetectedSummary();
    renderPriceReview();
    renderResultCardScreen();
  }
});

results.addEventListener("keydown", (event) => {
  if (event.key !== "Enter" && event.key !== " ") return;
  const card = event.target.closest("[data-select-card]");
  if (!card) return;
  event.preventDefault();
  if (state.scanStage === "result") {
    showNotice("Le match est deja verrouille pour cette estimation. Utilise Modifier l'analyse pour changer de carte.");
    return;
  }
  state.selectedMatchId = card.dataset.selectCard;
  state.priceReview = null;
  renderResults();
  renderDetectedSummary();
  renderPriceReview();
  renderResultCardScreen();
});

if (detectedSummary) {
  detectedSummary.addEventListener("click", (event) => {
    const selectId = event.target.closest("[data-select-detected-match]")?.dataset.selectDetectedMatch;
    if (!selectId || selectId === state.selectedMatchId) return;
    state.selectedMatchId = selectId;
    state.priceReview = null;
    renderResults();
    renderDetectedSummary();
    renderPriceReview();
    renderResultCardScreen();
  });
}

tabButtons.forEach((button) => {
  button.addEventListener("click", () => {
    switchView(button.dataset.viewTarget);
  });
});

conditionButtons.forEach((button) => {
  button.addEventListener("click", () => {
    setCondition(button.dataset.condition);
  });
});

if (catalogSearch) {
  catalogSearch.addEventListener("input", () => {
    state.catalogQuery = catalogSearch.value;
    renderCatalog();
  });
}

if (catalogGameFilter) {
  catalogGameFilter.addEventListener("click", (event) => {
    const game = event.target.closest("[data-catalog-game]")?.dataset.catalogGame;
    if (!game) return;
    state.catalogGame = game;
    renderCatalogControls();
    renderCatalog();
  });
}

if (catalogSort) {
  catalogSort.addEventListener("click", (event) => {
    const sort = event.target.closest("[data-catalog-sort]")?.dataset.catalogSort;
    if (!sort) return;
    state.catalogSort = sort;
    renderCatalogControls();
    renderCatalog();
  });
}

form.addEventListener("submit", (event) => {
  event.preventDefault();
  searchCards();
});
form.addEventListener("input", handleFormEdit);
form.addEventListener("change", handleFormEdit);

imageInput.addEventListener("change", () => {
  readSelectedImage(imageInput.files?.[0]).catch((error) => showNotice(error.message, "error"));
});

if (imagePreview) {
  imagePreview.addEventListener("click", activatePreviewCapture);
  imagePreview.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    activatePreviewCapture();
  });
}

if (cameraButton) {
  cameraButton.addEventListener("click", () => startCamera().catch((error) => showNotice(error.message, "error")));
}

if (galleryButton) {
  galleryButton.addEventListener("click", openGalleryPicker);
}

if (capturePhotoButton) {
  capturePhotoButton.addEventListener("click", () => captureCameraFrame().catch((error) => showNotice(error.message, "error")));
}

if (switchCameraButton) {
  switchCameraButton.addEventListener("click", () => switchCameraFacing().catch((error) => showNotice(error.message, "error")));
}

if (stopCameraButton) {
  stopCameraButton.addEventListener("click", () => stopCameraStream({ resetPreview: true }));
}

detectButton.addEventListener("click", detectCard);
searchButton.addEventListener("click", searchCards);
manualButton.addEventListener("click", () => addMatch(manualMatch()));

if (manualEntryButton) {
  manualEntryButton.addEventListener("click", enterManualCondition);
}

if (editDetectionButton) {
  editDetectionButton.addEventListener("click", enterManualCondition);
}

function enterManualCondition() {
  hideNotice();
  state.detectedCard = null;
  state.lastDetectionSource = "manual_search";
  state.matches = [];
  state.selectedMatchId = null;
  state.priceReview = null;
  state.lastEstimateAt = null;
  renderDetectedSummary();
  renderResults();
  renderPriceReview();
  renderResultCardScreen();
  setScanStage("condition");
}

if (backPhotoButton) {
  backPhotoButton.addEventListener("click", () => {
    hideNotice();
    setScanStage("capture");
  });
}

if (backVerifyPhotoButton) {
  backVerifyPhotoButton.addEventListener("click", () => {
    hideNotice();
    setScanStage("capture");
  });
}

if (confirmMatchButton) {
  confirmMatchButton.addEventListener("click", () => {
    if (state.matches.length && !state.selectedMatchId) {
      showNotice("Choisis le visuel exact avant de renseigner l'etat.", "error");
      return;
    }
    hideNotice();
    setScanStage("condition");
  });
}

if (newScanButton) {
  newScanButton.addEventListener("click", resetScanForNextCard);
}

if (backConditionButton) {
  backConditionButton.addEventListener("click", () => {
    hideNotice();
    setScanStage(state.matches.length > 1 ? "verify" : "condition");
  });
}

if (backToCatalog) {
  backToCatalog.addEventListener("click", () => switchView("catalog"));
}

if (openCostsButton) {
  openCostsButton.addEventListener("click", () => {
    switchView("costs");
    refreshAiUsage().catch((error) => {
      if (costsSummary) costsSummary.innerHTML = `<div class="empty-line">${escapeHtml(error.message)}</div>`;
    });
  });
}

if (backProfileButton) {
  backProfileButton.addEventListener("click", () => switchView("profile"));
}

if (refreshCostsButton) {
  refreshCostsButton.addEventListener("click", () => {
    refreshAiUsage().catch((error) => showNotice(error.message, "error"));
  });
}

if (addSelectedButton) {
  addSelectedButton.addEventListener("click", () => {
    const match = selectedMatch();
    if (match) addMatch(match);
  });
}

document.querySelector("#refresh-network").addEventListener("click", refreshNetwork);
document.querySelector("#clear-network").addEventListener("click", async () => {
  if (!confirm("Vider le journal reseau ?")) return;
  await fetch("/api/network-events", {
    method: "DELETE",
    credentials: "include"
  });
  renderNetwork([]);
});

document.querySelector("#clear-catalog").addEventListener("click", async () => {
  if (!confirm("Vider tout le classeur local ?")) return;
  await fetch("/api/catalog", {
    method: "DELETE",
    credentials: "include"
  });
  await refreshCatalog();
  state.matches = [];
  state.selectedMatchId = null;
  renderResults();
});

if (copyAttempted) {
  copyAttempted.addEventListener("click", () => {
    const text = (state.lastAttemptedQueries || []).map((q) => (typeof q === "string" ? q : JSON.stringify(q))).join("\n");
    if (!text) return showNotice("Aucune requete a copier", "error");
    navigator.clipboard?.writeText(text).then(
      () => showNotice("Requetes copiees dans le presse-papiers."),
      () => showNotice("Impossible de copier", "error")
    );
  });
}

if (clearAttempted) {
  clearAttempted.addEventListener("click", () => {
    state.lastAttemptedQueries = [];
    renderAttemptedQueries();
  });
}

if (authForm) {
  authForm.addEventListener("submit", async (event) => {
    event.preventDefault();
    const submitButton = authForm.querySelector("button[type='submit']");
    if (submitButton) submitButton.disabled = true;
    if (authError) authError.hidden = true;
    try {
      const payload = await api("/api/auth/login", {
        method: "POST",
        body: JSON.stringify({
          userId: authUserId?.value,
          accessToken: authAccessToken?.value
        })
      });
      state.authUser = payload.user;
      state.currentUserId = payload.user?.id || normalizeUserId(authUserId?.value) || "local-user";
      try {
        window.localStorage?.setItem("valeo:userId", state.currentUserId);
      } catch {
        // Storage can be unavailable in private or embedded contexts.
      }
      if (authAccessToken) authAccessToken.value = "";
      hideAuthScreen();
      await refreshAuthenticatedData();
    } catch (error) {
      showAuthScreen(error.message || "Acces refuse.");
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  });
}

async function logoutCurrentUser() {
  stopCameraStream({ resetPreview: true });
  await api("/api/auth/logout", { method: "POST", body: "{}" }).catch(() => undefined);
  state.authUser = null;
  state.quotas = null;
  state.catalogItems = [];
  renderCatalog();
  renderStats();
  renderQuotas();
  showAuthScreen("");
}

if (logoutButton) {
  logoutButton.addEventListener("click", logoutCurrentUser);
}

if (headerLogoutButton) {
  headerLogoutButton.addEventListener("click", logoutCurrentUser);
}

window.addEventListener("pagehide", () => stopCameraStream());

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState !== "hidden") return;
  if (state.cameraStarting) return;
  if (state.cameraActive) stopCameraStream({ resetPreview: true });
});

async function bootstrap() {
  setScanStage("capture");
  updateDetectButtonState();
  updateCameraControls();
  renderDetectedSummary();
  renderResultCardScreen();
  try {
    await loadSession();
    await refreshAuthenticatedData();
  } catch {
    showAuthScreen("");
  }
}

bootstrap();
